(function () {
  function redirectStaleThemeRoutes() {
    const redirects = new Map([
      ['/collections/akrapovic-exhaust-week', '/collections/akrapovic'],
      ['/collections/akrapovic-exhausts', '/collections/akrapovic'],
      ['/collections/deals', '/pages/deals'],
      ['/pages/p4m-deals', '/pages/deals'],
      ['/pages/current-deals', '/pages/deals'],
    ]);
    const target = redirects.get(window.location.pathname);
    if (!target) return;

    window.location.replace(`${target}${window.location.search}${window.location.hash}`);
  }

  redirectStaleThemeRoutes();

  const STORAGE_KEY = 'p4m_selected_ride';
  const LIVE_FITMENT_KEYS = new Set(
    Array.isArray(window.P4M_FITMENT_LIVE_RIDES?.keys)
      ? window.P4M_FITMENT_LIVE_RIDES.keys
      : []
  );
  const LIVE_FITMENT_RIDES = Array.isArray(window.P4M_FITMENT_LIVE_RIDES?.rides)
    ? window.P4M_FITMENT_LIVE_RIDES.rides
      .map((row) => ({
        year: String(row?.[0] || '').trim(),
        make: String(row?.[1] || '').trim(),
        model: String(row?.[2] || '').trim(),
        fitmentKey: String(row?.[3] || '').trim(),
      }))
      .filter((row) => row.year && row.make && row.model && LIVE_FITMENT_KEYS.has(row.fitmentKey))
    : [];
  const BASE_VEHICLES = Array.isArray(window.vehicleData) ? window.vehicleData : [];
  const HARLEY_REGISTRY = Array.isArray(window.P4M_HARLEY_REGISTRY) ? window.P4M_HARLEY_REGISTRY : [];
  const HARLEY_VEHICLES = HARLEY_REGISTRY
    .map((record) => ({
      make: 'Harley-Davidson',
      year: Number(record?.[0]),
      model: String(record?.[1] || '').trim(),
      tagModels: Array.isArray(record?.[2]) ? record[2].map((value) => String(value || '').trim()).filter(Boolean) : [],
    }))
    .filter((record) => Number.isFinite(record.year) && record.model && record.tagModels.length);
  const HAS_HARLEY_REGISTRY = HARLEY_VEHICLES.length > 0;
  const HARLEY_DISPLAY_MODELS = new Map(HARLEY_VEHICLES.map((record) => [record.model.toLowerCase(), record.model]));
  const vehicleYears = (make, model, years) => years.map((year) => ({ make, model, year }));
  const SUPPLEMENTAL_VEHICLES = [
    ...vehicleYears('Harley-Davidson', 'XL1200X Forty-Eight', [2015, 2018, 2019, 2020, 2021]),
    ...vehicleYears('Harley-Davidson', 'FLHXSE CVO Street Glide', [2017, 2018, 2019, 2020, 2021]),
    ...vehicleYears('Harley-Davidson', 'FLTRXSE CVO Road Glide', [2018, 2019, 2020, 2021]),
    ...vehicleYears('Harley-Davidson', 'FLTRX Road Glide', [2017, 2018, 2019, 2020, 2021]),
    ...vehicleYears('Harley-Davidson', 'FLTRK Road Glide Limited', [2020, 2021]),
    ...vehicleYears('Harley-Davidson', 'FLTRXS Road Glide Special', [2017, 2018, 2019, 2020, 2021]),
    ...vehicleYears('Harley-Davidson', 'FLHR Road King', [2017, 2018, 2019, 2020, 2021]),
    ...vehicleYears('Harley-Davidson', 'FLHRXS Road King Special', [2017, 2018, 2019, 2020, 2021]),
    ...vehicleYears('Harley-Davidson', 'FLHX Street Glide', [2017, 2018, 2019, 2020, 2021]),
    ...vehicleYears('Harley-Davidson', 'FLHXS Street Glide Special', [2017, 2018, 2019, 2020, 2021]),
    ...vehicleYears('Harley-Davidson', 'FLHTK Ultra Limited', [2017, 2018, 2019, 2020, 2021]),
    ...vehicleYears('Honda', 'CRF250X', [2010, 2011]),
    ...vehicleYears('Indian', 'Scout', [2024]),
    ...vehicleYears('KTM', '1290 Super Adventure', [2017, 2018, 2019]),
    ...vehicleYears('Triumph', 'Tiger 800', [2017]),
  ];
  const SELECTOR_BASE_VEHICLES = HAS_HARLEY_REGISTRY
    ? BASE_VEHICLES.filter((item) => String(item.make || '').trim().toLowerCase() !== 'harley-davidson')
    : BASE_VEHICLES;
  const baseVehicleKeys = new Set(SELECTOR_BASE_VEHICLES.map((item) => `${item.year}::${item.make}::${item.model}`));
  const VEHICLES = [
    ...SELECTOR_BASE_VEHICLES,
    ...SUPPLEMENTAL_VEHICLES.filter((item) => (!HAS_HARLEY_REGISTRY || item.make !== 'Harley-Davidson') && !baseVehicleKeys.has(`${item.year}::${item.make}::${item.model}`)),
    ...HARLEY_VEHICLES,
  ];
  const SELECTOR_VEHICLES = LIVE_FITMENT_RIDES.length ? LIVE_FITMENT_RIDES : VEHICLES;

  const normalize = (value) => String(value || '').trim();
  const normalizeVehicleMake = (value) => {
    const make = normalize(value);
    if (/^cfmoto$/i.test(make)) return 'CFMoto';
    if (/^gasgas$/i.test(make)) return 'GASGAS';
    return make;
  };
  const uniqueSorted = (items, numericDesc) => {
    const values = Array.from(new Set(items.map(normalize).filter(Boolean)));
    if (numericDesc) {
      return values.sort((a, b) => Number(b) - Number(a));
    }
    return values.sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }));
  };

  const trimNoiseTokens = new Set([
    'abs',
    'non',
    'without',
    'with',
    'w',
    'wo',
    'base',
    'standard',
    'std',
    'premium',
    'deluxe',
    'icon',
    'krt',
    'edition',
  ]);

  const hiddenVehicleModelKeys = new Set([
    'benelli::leoncino / trail 500',
    'benelli::leoncino/trail 500',
    'gasgas::250 500 enduro',
    'honda::cb650f / cb650r / cbr650f / cbr650r',
    'honda::cbr500r / cb500f / cb500x / cbr300r',
    'kawasaki::en650 / versys 650 / versys 1000 / z650 / z900 / z900rs',
  ]);

  const vehicleModelAliases = new Map([
    ['benelli::leoncino 500 trail', 'Trail 500'],
    ['bmw::f850gs', 'F850 GS'],
    ['bmw::f850gs adventure', 'F850 GS'],
    ['bmw::k1600 grand america', 'K1600 B/Grand America'],
    ['bmw::k1600b', 'K1600 B/Grand America'],
    ['bmw::k1600gt', 'K1600 GT'],
    ['bmw::k1600gtl', 'K1600 GTL'],
    ['bmw::r 1250', ''],
    ['bmw::r1250', ''],
    ['bmw::r1250gs', 'R1250 GS'],
    ['bmw::r1250r', 'R1250 R'],
    ['honda::atc250es big red', 'ATC250ES'],
    ['honda::cb750 hornet', 'Hornet 750'],
    ['honda::crf125f big wheel', 'CRF125F'],
    ['honda::crf150r expert', 'CRF150R'],
    ['honda::crf250l rally', 'CRF250L'],
    ['honda::crf300l rally', 'CRF300L'],
    ['honda::crf450r-s', 'CRF450R'],
    ['honda::grom 125', 'Grom'],
    ['honda::trx250ex sportrax', 'TRX250EX'],
    ['honda::trx400ex sportrax', 'TRX400EX'],
    ['honda::trx90 sportrax', 'TRX90'],
    ['honda::trx90ex sportrax', 'TRX90EX'],
  ]);

  function vehicleModelKey(make, model) {
    return `${normalize(make).toLowerCase()}::${normalize(model).toLowerCase()}`;
  }

  function harleyVehicleModelAlias(model) {
    const modelText = normalize(model);
    if (!modelText) return null;
    const canonicalDisplayModel = HARLEY_DISPLAY_MODELS.get(modelText.toLowerCase());
    if (canonicalDisplayModel) return canonicalDisplayModel;

    if (/^(?:GOLD-\d|RED-\d|Gunmetal Gray\b)/i.test(modelText)) return '';
    if (/^Softail Twin Slash\b/i.test(modelText)) return '';
    if (/^Touring\s+\d+\s+\d+\s+High Output Pcx$/i.test(modelText)) return '';
    if (/^Fat Boy Flstf\s+\d{3,}[A-Z]*$/i.test(modelText)) return 'Fat Boy';
    if (/^Street Rod\s+XG750A$/i.test(modelText)) return 'Street Rod';

    const leadingModelCode = modelText.match(/^(FLHCS|FLFBS|FXBBS|FXFBS)\s+(.+)$/i);
    if (leadingModelCode) {
      const readableModel = leadingModelCode[2].replace(/\s+114$/i, '').trim();
      if (/^Heritage Classic\b/i.test(readableModel)) return 'Heritage Classic';
      if (/^Fat Boy\b/i.test(readableModel)) return 'Fat Boy';
      if (/^Street Bob\b/i.test(readableModel)) return 'Street Bob';
      if (/^Fat Bob\b/i.test(readableModel)) return 'Fat Bob';
      return readableModel;
    }

    if (/^Softail\s+\d{3,}[A-Z]*$/i.test(modelText)) return 'Softail';
    if (/^Sportster\s+Xl\s+\d{3,}[A-Z]*$/i.test(modelText)) return 'Sportster XL';

    const codedModel = modelText.match(/^(FLHRXS|FLHR|FLHTK|FLHXSE|FLHXST|FLHXS|FLHX|FLTRKSE|FLTRK|FLTRXSE|FLTRXST|FLTRXS|FLTRX|FLRT|XL1200X)\s+(.+)$/i);
    if (codedModel) {
      const readableModel = codedModel[2].trim();
      if (/^Forty[- ]Eight$/i.test(readableModel)) return 'Forty-Eight';
      return readableModel.replace(/^CVO\s+/i, 'CVO ');
    }

    if (/^Forty\s+Eight$/i.test(modelText)) return 'Forty-Eight';

    return null;
  }

  function familyVehicleModelAlias(make, model) {
    const makeKey = normalize(make).toLowerCase();
    const modelText = normalize(model);

    if (makeKey === 'aprilia') {
      if (/^rs\s*660$/i.test(modelText)) return 'RS 660';
      if (/^rsv[- ]?4$/i.test(modelText)) return 'RSV4';
      if (/^rsv[- ]?4\s+(?:rr|rf|gloss|matt)$/i.test(modelText)) return 'RSV4';
      if (/^rsv[- ]?4\s+1100$/i.test(modelText)) return 'RSV4 1100';
      if (/^sx[-\s]*v\s*4[\s.-]*5$/i.test(modelText)) return 'SXV 4.5';
      if (/^sx[-\s]*v\s*5[\s.-]*5$/i.test(modelText)) return 'SXV 5.5';
      if (/^tuono\s+1100\s+v4$/i.test(modelText)) return 'Tuono V4 1100';
      if (/^tuono v4\s+1100\s*rr$/i.test(modelText)) return 'Tuono V4 1100';
    }

    if (makeKey === 'beta') {
      const betaModel = modelText.match(/^(\d{2,3})\s*(rr|rx)$/i);
      if (betaModel) return `${betaModel[1]} ${betaModel[2].toUpperCase()}`;
      const reversedBetaModel = modelText.match(/^(rr|rx)[-\s]*(\d{2,3})$/i);
      if (reversedBetaModel) return `${reversedBetaModel[2]} ${reversedBetaModel[1].toUpperCase()}`;
    }

    if (makeKey === 'benelli' && /^bn[-\s]*302s?$/i.test(modelText)) return '302S';

    if (makeKey === 'bmw') {
      if (/^f\s*650\s*gs$/i.test(modelText)) return 'F650 GS';
      if (/^f\s*650\s*gs\s+e8gs$/i.test(modelText)) return 'F650 GS';
      if (/^f\s*700\s*gs$/i.test(modelText)) return 'F700 GS';
      if (/^f\s*750\s*gs(?:\s+4g85)?$/i.test(modelText)) return 'F750 GS';
      if (/^f\s*800\s*gs(?:\s+adventure)?$/i.test(modelText)) return 'F800 GS';
      if (/^f\s*850\s*gs(?:\s+adventure)?$/i.test(modelText)) return 'F850 GS';
      if (/^f\s*900\s*gs(?:\s+adventure)?$/i.test(modelText)) return 'F900 GS';
      if (/^f\s*900\s*gs\s+adv$/i.test(modelText)) return 'F900 GS';
      if (/^m\s*1000\s*rr$/i.test(modelText)) return 'M1000 RR';
      if (/^m\s*1000\s*r$/i.test(modelText)) return 'M1000R';
      if (/^m\s*1000\s*xr$/i.test(modelText)) return 'M1000XR';
      if (/^k\s*1600\s+(?:bagger|b)\b/i.test(modelText)) return 'K1600 B/Grand America';
      if (/^k\s*1600\s+grand\s+america$/i.test(modelText)) return 'K1600 B/Grand America';
      if (/^k\s*1600\s+gt$/i.test(modelText)) return 'K1600 GT';
      if (/^k\s*1600\s+gtl$/i.test(modelText)) return 'K1600 GTL';
      if (/^r\s*1200$/i.test(modelText)) return '';
      if (/^r\s*1200\s*gs(?:\s+adventure)?$/i.test(modelText)) return 'R1200 GS';
      if (/^r\s*1200\s*r$/i.test(modelText)) return 'R1200 R';
      if (/^r\s*1200\s*rs$/i.test(modelText)) return 'R1200 RS';
      if (/^r\s*1200\s*rt$/i.test(modelText)) return 'R1200 RT';
      if (/^r\s*1250\s+r(?:\s+r)?\s*1250$/i.test(modelText)) return 'R1250 R';
      if (/^r\s*1250\s*gs$/i.test(modelText)) return 'R1250 GS';
      if (/^r\s*1250\s*r$/i.test(modelText)) return 'R1250 R';
      if (/^r\s*1250$/i.test(modelText)) return '';
      if (/^r\s*1250\s*rt$/i.test(modelText)) return 'R1250 RT';
      if (/^r\s*1300(?:\s*gs)?(?:\s+r\s*1300)?$/i.test(modelText)) return 'R1300 GS';
      if (/^s\s*1000\s*rr\b/i.test(modelText)) return 'S1000 RR';
    }

    if (makeKey === 'harley-davidson') {
      const harleyAlias = harleyVehicleModelAlias(modelText);
      if (harleyAlias !== null) return harleyAlias;
    }

    if (makeKey === 'can-am') {
      if (/^commander\b/i.test(modelText)) return 'Commander';
      if (/^defender\b/i.test(modelText)) return 'Defender';
      if (/^maverick x3\b/i.test(modelText)) return 'Maverick X3';
      if (/^outlander\b/i.test(modelText)) return 'Outlander';
      if (/^renegade\b/i.test(modelText)) return 'Renegade';
      if (/^ryker\b/i.test(modelText)) return 'Ryker';
      return '';
    }

    if (makeKey === 'cfmoto' && /^700\s*cl[-\s]*x\b/i.test(modelText)) {
      return '700CL-X';
    }

    if (makeKey === 'cfmoto') {
      if (/^450\s*mt$/i.test(modelText)) return '450MT';
      if (/^675\s*sr\s*r$/i.test(modelText)) return '675SR-R';
      if (/^800\s*mt$/i.test(modelText)) return '800MT';
      if (/^800\s*mt\s+800\s*mt$/i.test(modelText)) return '800MT';
      if (/^800\s*nk\b/i.test(modelText)) return '800NK';
    }

    if (makeKey === 'ducati') {
      if (/\bscrambler\b/i.test(modelText)) {
        if (/\b1100\b/i.test(modelText)) return 'Scrambler 1100';
        if (/\bsixty2\b/i.test(modelText)) return 'Scrambler Sixty2';
        return 'Scrambler 800';
      }
      const panigaleModel = modelText.match(/^(?:panigale\s+)?(899|959|1199|1299)(?:\s+panigale)?$/i);
      if (panigaleModel) return `Panigale ${panigaleModel[1]}`;
      if (/^monster\s+937\b/i.test(modelText)) return 'Monster 937';
      if (/^monster\s+696\b/i.test(modelText)) return 'Monster 696';
      if (/^monster\s+1200\s+110\s*kw\b/i.test(modelText)) return 'Monster 1200';
      if (/^monster\s+821\s+1200$/i.test(modelText)) return 'Monster 821';
      if (/^monster\s+1200\s+s\b/i.test(modelText)) return 'Monster 1200';
      if (/^panigale\s+v4(?:\s+s)?(?:\s+(?:gold|red))?$/i.test(modelText)) return 'Panigale V4';
      if (/^multistrada\s+950(?:\s*\/\s*s)?$/i.test(modelText)) return 'Multistrada 950';
      if (/^multistrada\s+1200\s*s(?:\s+(?:d-air|dvt))?$/i.test(modelText)) return 'Multistrada 1200';
      if (/^multistrada\s+1260\s*s$/i.test(modelText)) return 'Multistrada 1260';
      if (/^x\s*diavel$/i.test(modelText)) return 'XDiavel';
      if (/^x\s*diavel\s+v4$/i.test(modelText)) return 'XDiavel V4';
    }

    if (makeKey === 'gasgas') {
      const gasGasModel = modelText.match(/^(ec|es|ex|mc)[-\s]*(\d{2,3})(f?)$/i);
      if (gasGasModel) return `${gasGasModel[1].toUpperCase()} ${gasGasModel[2]}${gasGasModel[3].toUpperCase()}`;
    }

    if (makeKey === 'honda') {
      if (/\bafrica\s+twin\b/i.test(modelText) || /^crf[-\s]*(?:1000|1100)l$/i.test(modelText)) {
        if (/\b1100\b/i.test(modelText) || /crf[-\s]*1100l/i.test(modelText)) return 'Africa Twin 1100';
        if (/\b1000\b/i.test(modelText) || /crf[-\s]*1000l/i.test(modelText)) return 'Africa Twin 1000';
        if (/\b750\b/i.test(modelText) || /xrv[-\s]*750/i.test(modelText)) return 'Africa Twin 750';
        return 'Africa Twin';
      }
      if (/^rancher\s+420\b/i.test(modelText)) return 'Rancher 420';
      if (/^cb[-\s]*600\s*f\s+hornet$/i.test(modelText)) return 'Hornet 600';
      if (/^cb[-\s]*1000\s*r\b/i.test(modelText)) return 'CB1000R';
      if (/^cbr10spm\s+cbr1000rr\b/i.test(modelText)) return 'CBR1000RR';
      if (/^cmx[-\s]*500\s+rebel$/i.test(modelText)) return 'Rebel 500';
      if (/^cmx[-\s]*1100\s+rebel$/i.test(modelText)) return 'Rebel 1100';
      if (/^gl1800\s+gold\s+wing\b/i.test(modelText)) return 'Gold Wing';
      if (/^trx350d\s+fourtrax\s+foreman\b/i.test(modelText)) return 'TRX350D';
      if (/^crf[-\s]*230l\s+street\s+model\b/i.test(modelText)) return 'CRF230L';
      if (/^crf[-\s]*450r\s+evo\s+r\s+mx$/i.test(modelText)) return 'CRF450R';
      if (/^crf[-\s]*250l\s+rally$/i.test(modelText)) return 'CRF250L';
      if (/^crf[-\s]*300l\s+rally$/i.test(modelText)) return 'CRF300L';
      let hondaModel = modelText.match(/^cb[-\s]*(\d{3,4})\s*([a-z]?)$/i);
      if (hondaModel) return `CB${hondaModel[1]}${hondaModel[2].toUpperCase()}`;
      hondaModel = modelText.match(/^cbr[-\s]*(\d{3,4})\s*(rr|r)?(?:\s+(.+))?$/i);
      if (hondaModel) {
        const canonicalCbr = `CBR${hondaModel[1]}${(hondaModel[2] || '').toUpperCase()}`;
        return /^CBR1000RR$/i.test(canonicalCbr) ? 'CBR1000RR' : `${canonicalCbr}${hondaModel[3] ? ` ${hondaModel[3]}` : ''}`;
      }
      hondaModel = modelText.match(/^crf[-\s]*(\d{3,4})\s*([a-z]?)(?:\s+(.+))?$/i);
      if (hondaModel) return `CRF${hondaModel[1]}${hondaModel[2].toUpperCase()}${hondaModel[3] ? ` ${hondaModel[3]}` : ''}`;
      hondaModel = modelText.match(/^nc[-\s]*(\d{3,4})\s*([a-z]?)$/i);
      if (hondaModel) return `NC${hondaModel[1]}${hondaModel[2].toUpperCase()}`;
      hondaModel = modelText.match(/^pcx[-\s]*(\d{3})$/i);
      if (hondaModel) return `PCX${hondaModel[1]}`;
      hondaModel = modelText.match(/^trx[-\s]*(\d{2,4})\s*([a-z]{0,2})$/i);
      if (hondaModel) return `TRX${hondaModel[1]}${hondaModel[2].toUpperCase()}`;
      hondaModel = modelText.match(/^xl[-\s]*(\d{3})(?:\s+(.+))?$/i);
      if (hondaModel) return `XL${hondaModel[1]}${hondaModel[2] ? ` ${hondaModel[2]}` : ''}`;
      hondaModel = modelText.match(/^xr[-\s]*(\d{3})\s*([a-z]?)$/i);
      if (hondaModel) return `XR${hondaModel[1]}${hondaModel[2].toUpperCase()}`;
    }

    if (makeKey === 'husqvarna') {
      const husqvarnaModel = modelText.match(/^fe\s*(\d{3})$/i);
      if (husqvarnaModel) return `FE ${husqvarnaModel[1]}`;
      if (/^vitpilen\s+701\s+svartpilen\s+701\b/i.test(modelText)) return 'Vitpilen 701';
    }

    if (makeKey === 'indian') {
      if (/^scout\s+4(?:\.5|\s+5)?in\s+grand\s+national$/i.test(modelText)) return 'Scout';
      if (/^scout\s+twin\s+slash\s+3in\b/i.test(modelText)) return 'Scout';
    }

    if (makeKey === 'kawasaki') {
      if (/^(?:ninja\s+)?zx[-\s]*6r(?:\s*\/\s*zx?636|\s+636|\s+\d+[a-z]*|\s+vs\s+6|\s+grid\s+o|\s+streetfighter)?$/i.test(modelText)) {
        return 'ZX-6R';
      }
      if (/^zx\s*636(?:\s+ninja\s+zx[-\s]*6r)?/i.test(modelText)) return 'ZX-6R';
      if (/^636$/i.test(modelText)) return 'ZX-6R';
      if (/^(?:ninja\s+)?zx[-\s]*4r$/i.test(modelText)) return 'ZX-4R';
      if (/^(?:ninja\s+)?zx[-\s]*4rr$/i.test(modelText)) return 'ZX-4RR';
      if (/^(?:ninja\s+)?zx[-\s]*10r(?:\s+(?:gp|gloss|matt))?$/i.test(modelText)) return 'ZX-10R';
      if (/^(?:ninja\s+)?zx[-\s]*10rr$/i.test(modelText)) return 'ZX-10RR';
      if (/^(?:ninja\s+)?zx[-\s]*25r$/i.test(modelText)) return 'ZX-25R';
      if (/^ninja\s+zx[-\s]*14r$/i.test(modelText)) return 'ZX-14R';
      if (/^brute\s+force\s+300\b/i.test(modelText)) return 'Brute Force 300';
      if (/^brute\s+force\s+650\s+irs\b/i.test(modelText)) return 'Brute Force 650 IRS';
      if (/^brute\s+force\s+650\s+straight\s+axle\b/i.test(modelText)) return 'Brute Force 650 Straight Axle';
      if (/^brute\s+force\s+750\s+irs\b/i.test(modelText)) return 'Brute Force 750 IRS';
      if (/^krf750\s+teryx\b/i.test(modelText)) return 'Teryx 750';
      if (/^krt750\s+teryx4\b/i.test(modelText)) return 'Teryx4 750';
      if (/^klr[-\s]*650$/i.test(modelText)) return 'KLR650';
      if (/^klr[-\s]*650\s+camo$/i.test(modelText)) return 'KLR650';
      if (/^(?:500\s+ninja|ninja\s+500)$/i.test(modelText)) return 'Ninja 500';
      if (/^ninja\s*1000\s*sx$/i.test(modelText)) return 'Ninja 1000SX';
      if (/^ninja\s*1000\s*sx\s+nxt$/i.test(modelText)) return 'Ninja 1000SX';
      if (/^ninja\s*1100\s*sx$/i.test(modelText)) return 'Ninja 1100SX';
      if (/^ninja\s+h2\s+sx(?:\s+se)?$/i.test(modelText)) return 'Ninja H2 SX';
      if (/^ninja\s+400\s+ex400$/i.test(modelText)) return 'Ninja 400';
      if (/^versys\s*1000(?:\s+se\s+lt\+)?$/i.test(modelText)) return 'Versys 1000';
      if (/^vulcan\s+s(?:\s+650)?$/i.test(modelText)) return 'Vulcan S';
      if (/^j[-\s]*300$/i.test(modelText)) return 'J300';
      const kfxModel = modelText.match(/^kfx[-\s]*(80|400)$/i);
      if (kfxModel) return `KFX${kfxModel[1]}`;
      if (/^kfx[-\s]*450r(?:\s+head)?$/i.test(modelText)) return 'KFX450R';
      const klxModel = modelText.match(/^klx[-\s]*(125|250|450r)$/i);
      if (klxModel) return `KLX${klxModel[1].toUpperCase()}`;
      if (/^klx[-\s]*250\s+camo$/i.test(modelText)) return 'KLX250';
      if (/^klx110r\s+l$/i.test(modelText)) return 'KLX110R';
      if (/^klx140(?:r\s*)?[fl]$/i.test(modelText) || /^klx140[gl]$/i.test(modelText)) return 'KLX140R';
      const kxModel = modelText.match(/^kx[-\s]*(250f|450f)$/i);
      if (kxModel) return `KX${kxModel[1].toUpperCase()}`;
      if (/^z\s*h2$/i.test(modelText)) return 'Z H2';
      if (/^z[-\s]*900$/i.test(modelText)) return 'Z900';
      if (/^z[-\s]*900(?:e|\s+a2)$/i.test(modelText)) return 'Z900';
      if (/^z[-\s]*900\s*rs$/i.test(modelText)) return 'Z900RS';
      if (/^z[-\s]*800\s+e$/i.test(modelText)) return 'Z800';
      if (/^zx[-\s]*14$/i.test(modelText)) return 'ZX-14';

      const ninjaNumber = modelText.match(/^ninja\s+(\d{3,4})(?:\s+(?:abs|se|krt(?:\s+edition)?|special\s+edition))*$/i);
      if (ninjaNumber) return `Ninja ${ninjaNumber[1]}`;
    }

    if (makeKey === 'ktm') {
      let dukeModel = modelText.match(/^(?:duke\s+)?(390|790|990)(?:\s+duke)?$/i);
      if (dukeModel) return `${dukeModel[1]} Duke`;
      dukeModel = modelText.match(/^(?:duke\s+)?890\s*r(?:\s+duke)?$/i);
      if (dukeModel) return '890 Duke R';
      let ktmModel = modelText.match(/^(\d{2,4})\s*(sx|xc)$/i);
      if (ktmModel) return `${ktmModel[1]} ${ktmModel[2].toUpperCase()}`;
      ktmModel = modelText.match(/^(\d{2,4})\s*(sx[-\s]*f|xc[-\s]*f|xc[-\s]*w|exc[-\s]*f|exc[-\s]*r)(.*)$/i);
      if (ktmModel) {
        const suffix = ktmModel[2].toUpperCase().replace(/\s+/g, '-').replace(/^SXF$/, 'SX-F').replace(/^XCF$/, 'XC-F').replace(/^XCW$/, 'XC-W').replace(/^EXCR$/, 'EXC-R');
        return `${ktmModel[1]} ${suffix}${ktmModel[3]}`;
      }
      if (/^790\s+adventure\s+r\s+mod$/i.test(modelText)) return '790 Adventure R';
      if (/^1290\s+super\s*adventure$/i.test(modelText)) return '1290 Super Adventure';
      if (/^(?:1290\s+super\s*duke|super\s*duke\s+1290)$/i.test(modelText)) return '1290 Super Duke';
      if (/^1290\s+super\s+duke\s+r\s+(?:hypercone|nxt)$/i.test(modelText)) return '1290 Super Duke R';
      if (/^1390(?:\s+super\s+duke)?$/i.test(modelText)) return '1390 Super Duke';
      if (/^890\s+smt$/i.test(modelText)) return '890 SMT';
    }

    if (makeKey === 'kymco' && /^k\s+xct\s+125\s+i$/i.test(modelText)) return 'K-XCT 125i';

    if (makeKey === 'moto guzzi' && /^v85\s*t{1,2}$/i.test(modelText)) return 'V85 TT';

    if (makeKey === 'moto morini' && /^x[-\s]*cape\s+650\s+a2$/i.test(modelText)) return 'X-Cape 650';

    if (makeKey === 'polaris') {
      if (/^general\s+1000(?:\s+explorer(?:\s+series\s+dual)?)?$/i.test(modelText)) return 'General 1000';
      if (/^outlaw\s+450\s+mxr\b/i.test(modelText)) return 'Outlaw 450 MXR';
      if (/^(?:ranger\s+)?rzr[-\s]*800(?:\s+(?:eps|single))?$/i.test(modelText)) return 'RZR 800';
      if (/^ranger\s+rzr\s+800\s+s$/i.test(modelText)) return 'RZR S 800';
      if (/^(?:ranger\s+)?rzr[-\s]*xp\s*900$/i.test(modelText)) return 'RZR XP 900';
      if (/^rzr\s+turbo\s+s(?:\s+(?:lifted\s+lime\s+le|velocity))?$/i.test(modelText)) return 'RZR Turbo S';
      if (/^rzr\s+turbo\s+s4(?:\s+(?:lifted\s+lime\s+le|velocity))?$/i.test(modelText)) return 'RZR Turbo S4';
      if (/^rzr\s+xp\s+4\s+1000(?:\s+eps)?$/i.test(modelText)) return 'RZR XP 4 1000';
      if (/^rzr\s+xp\s+1000(?:\s+eps)?$/i.test(modelText)) return 'RZR XP 1000';
      if (/^rzr\s+xp\s+turbo(?:\s+eps(?:\s+(?:dynamix\s+edition|fox\s+edition|le))?)?$/i.test(modelText)) return 'RZR XP Turbo';
      if (/^rzr\s+xp\s+turbo\s+s(?:\s+velocity)?$/i.test(modelText)) return 'RZR XP Turbo S';
      if (/^scrambler\s+xp\s+1000\b/i.test(modelText)) return 'Scrambler XP 1000';
      if (/^sportsman\s+500\s+ho\b/i.test(modelText)) return 'Sportsman 500 HO';
      if (/^sportsman\s+xp\s+1000\s+touring\b/i.test(modelText)) return 'Sportsman XP 1000 Touring';
      if (/^sportsman\s+xp\s+1000\b/i.test(modelText)) return 'Sportsman XP 1000';
    }

    if (makeKey === 'suzuki') {
      if (/^dr[-\s]*z\s*400e$/i.test(modelText)) return 'DR-Z400E';
      const drzModel = modelText.match(/^dr[-\s]*z\s*(110|125)$/i);
      if (drzModel) return `DR-Z${drzModel[1]}`;
      if (/^gsx[-\s]*s\s*1000$/i.test(modelText)) return 'GSX-S1000';
      const ltrModel = modelText.match(/^lt[-\s]*r\s*450\s+quadracer(\s+evo)?$/i);
      if (ltrModel) return 'LT-R450 Quadracer';
      const rmzModel = modelText.match(/^rm[-\s]*z\s*(250|450)$/i);
      if (rmzModel) return `RM-Z${rmzModel[1]}`;
      if (/^v[-\s]*strom\s*800\s*de$/i.test(modelText)) return 'V-Strom 800DE';
      if (/^(?:gsx1300r\s+)?hayabusa(?:\s+1300\s+gen\s+3)?$/i.test(modelText)) return 'Hayabusa';
    }

    if (makeKey === 'triumph') {
      if (/^765\s+daytona\s+675$/i.test(modelText)) return 'Daytona 675';
      if (/^(?:675\s+daytona|daytona\s+675)$/i.test(modelText)) return 'Daytona 675';
      if (/^(?:800\s+tiger\s+xc|tiger\s+800\s+xc)$/i.test(modelText)) return 'Tiger 800 XC';
      if (/^tiger\s+800$/i.test(modelText)) return 'Tiger 800';
      if (/^bonneville\s+bobber\s+euro\s*4\s+custom$/i.test(modelText)) return 'Bonneville Bobber';
      if (/^bonneville\s+t\s*120\s+bonneville\s+euro$/i.test(modelText)) return 'Bonneville T120';
      if (/^thruxton\s+1200\s+euro\s*4\s+tapered$/i.test(modelText)) return 'Thruxton 1200';
      if (/^bonneville\s+t\s*120\s+bonneville$/i.test(modelText)) return 'Bonneville T120';
      if (/^daytona\s+675\s+street$/i.test(modelText)) return 'Daytona 675';
      if (/^tiger\s+tiger\s+1200$/i.test(modelText)) return 'Tiger 1200';
    }

    if (makeKey === 'yamaha') {
      if (/^(?:yzf[-\s]?)?r1(?:m|s)?(?:\b|[\s/,-])/i.test(modelText)) return 'R1';
      if (/^(?:yzf[-\s]?)?r3(?:\b|[\s/,-])/i.test(modelText)) return 'R3';
      if (/^(?:yzf[-\s]?)?r6(?:\b|[\s/,-])/i.test(modelText)) return 'R6';
      if (/^(?:yzf[-\s]?)?r7(?:\b|[\s/,-])/i.test(modelText)) return 'R7';
      if (/^(?:yzf[-\s]?)?r9(?:\b|[\s/,-])/i.test(modelText)) return 'R9';
      if (/^pw[-\s]*80$/i.test(modelText)) return 'PW80';
      if (/^t\s*n\s*r\s*700$/i.test(modelText)) return 'Tenere 700';
      if (/^mt[-\s]*10\s+euro\s*4\s+nxt$/i.test(modelText)) return 'MT-10';
      if (/^(?:yfm700r\s+)?raptor\s+700(?:\s+(?:evo\s+r\s+dual|head))?$/i.test(modelText)) return 'Raptor 700';
      if (/^yfm700r\s+raptor$/i.test(modelText)) return 'Raptor 700';
      if (/^yfm660r\s+raptor$/i.test(modelText)) return 'Raptor 660';
      if (/^yfm250r\s+raptor$/i.test(modelText)) return 'Raptor 250R';
      if (/^ttr[-\s]*110(?:e)?$/i.test(modelText)) return 'TT-R110E';
      if (/^tt[-\s]*600$/i.test(modelText)) return 'TT600';
      if (/^yfm350fw\s+big\s+bear\s+4x4$/i.test(modelText)) return 'Big Bear 350';
      if (/^yxr66f\s+rhino\s+660\b/i.test(modelText)) return 'Rhino 660';
      if (/^(?:yxr700f\s+)?rhino\s+700(?:\s+(?:efi|fi))?$/i.test(modelText)) return 'Rhino 700';
      if (/^yxz1000r(?:\s+2\s+25in\s+dual)?$/i.test(modelText)) return 'YXZ1000R';
      if (/^(?:star\s+)?vmax\s+1700$/i.test(modelText)) return 'VMAX 1700';
      if (/^xt[-\s]*1200ze?\s+super\s+tenere$/i.test(modelText)) return 'XT1200Z';
      let yamahaModel = modelText.match(/^tt[-\s]*r[-\s]*(50e|110e|125|125le|230)$/i);
      if (yamahaModel) return `TT-R${yamahaModel[1].toUpperCase()}`;
      yamahaModel = modelText.match(/^wr[-\s]*(450f)$/i);
      if (yamahaModel) return `WR${yamahaModel[1].toUpperCase()}`;
      if (/^x[-\s]*max[-\s]*300$/i.test(modelText)) return 'XMAX 300';
      yamahaModel = modelText.match(/^xsr[-\s]*(700|900)$/i);
      if (yamahaModel) return `XSR${yamahaModel[1]}`;
      if (/^xt[-\s]*1200\s*z$/i.test(modelText)) return 'XT1200Z';
      yamahaModel = modelText.match(/^yfz[-\s]*(450r?)$/i);
      if (yamahaModel) return `YFZ${yamahaModel[1].toUpperCase()}`;
      yamahaModel = modelText.match(/^yz[-\s]*(250|450)\s*f$/i);
      if (yamahaModel) return `YZ${yamahaModel[1]}F`;
      if (/^yzf[-\s]*r[-\s]*125$/i.test(modelText)) return 'YZF-R125';
    }

    if (makeKey === 'vespa' && /^gts[-\s]*250(?:\s+i\.?e\.?)?$/i.test(modelText)) return 'GTS 250';

    if (makeKey === 'honda') {
      if (/^SXS10S2R(?:D)?\s+Talon 1000R\b/i.test(modelText)) return 'Talon 1000R';
      if (/^SXS10S2X(?:D)?\s+Talon 1000X\b/i.test(modelText)) return 'Talon 1000X';
      if (/^SXS10S4\s+Talon 1000X-4\b/i.test(modelText)) return 'Talon 1000X-4';
    }

    if (makeKey === 'suzuki') {
      if (/^(?:dl[-\s]?)?650\b.*v[-\s]?strom|^v[-\s]?strom\s*650\b/i.test(modelText)) return 'V-Strom 650';
      if (/^(?:dl[-\s]?)?1000\b.*v[-\s]?strom|^v[-\s]?strom\s*1000\b/i.test(modelText)) return 'V-Strom 1000';
      if (/^(?:dl[-\s]?)?1050\b.*v[-\s]?strom|^v[-\s]?strom\s*1050\b/i.test(modelText)) return 'V-Strom 1050';
      if (/^drz?[-\s]?125l\b/i.test(modelText)) return 'DR-Z125L';
      if (/^drz?[-\s]?400sm\b/i.test(modelText)) return 'DR-Z400SM';
      if (/^drz?[-\s]?400s\b/i.test(modelText)) return 'DR-Z400S';
      if (/^drz?[-\s]?400e\b/i.test(modelText)) return 'DR-Z400E';
      if (/^drz?[-\s]?400\b/i.test(modelText)) return 'DR-Z400';
      if (/^dr[-\s]?650(?:se|s)?\b/i.test(modelText)) return 'DR650S';
      if (/^gsx[-\s]?250r\b|^gsx250r\b/i.test(modelText)) return 'GSX250R';
      if (/^gsx[-\s]?1000r(?:\b|[\s/,-])/i.test(`${modelText} `)) return 'GSX-R1000';
      if (/^gsx[-\s]?r[-\s]?1000r?(?:\b|[\s/,-])|^gsxr[-\s]?1000r?(?:\b|[\s/,-])/i.test(`${modelText} `)) return 'GSX-R1000';
      if (/^gsx[-\s]?r[-\s]?750(?:\b|[\s/,-])|^gsxr[-\s]?750(?:\b|[\s/,-])/i.test(`${modelText} `)) return 'GSX-R750';
      if (/^gsx[-\s]?r[-\s]?600(?:\b|[\s/,-])|^gsxr[-\s]?600(?:\b|[\s/,-])/i.test(`${modelText} `)) return 'GSX-R600';
      if (/^gsx[-\s]?s[-\s]?750(?:\s*\/\s*z|[sxz])?(?:\b|[\s/,-])/i.test(`${modelText} `)) return 'GSX-S750';
      if (/^sv650x(?:\b|[\s/,-])/i.test(`${modelText} `) || /^sv650\s*\/\s*sv650x$/i.test(modelText)) return 'SV650';
      if (/^sv[-\s]?650\b/i.test(modelText)) return 'SV650';
      if (/^m109r\b/i.test(modelText)) return 'Boulevard M109R';
    }

    return null;
  }

  function aliasedVehicleModel(make, model) {
    const exactAlias = vehicleModelAliases.get(vehicleModelKey(make, model));
    if (exactAlias !== undefined) return exactAlias;
    const familyAlias = familyVehicleModelAlias(make, model);
    if (familyAlias !== null) return familyAlias;
    return model;
  }

  function isHiddenVehicleModel(make, model) {
    return hiddenVehicleModelKeys.has(vehicleModelKey(make, model));
  }

  function stripSupplierVehicleFragments(value) {
    return normalize(value)
      .replace(/\s+(?:double\s+)?grid\s+o(?:\s+semi\s+full)?\b.*$/i, '')
      .replace(/\s+green\s+street\b.*$/i, '')
      .replace(/\s+(?:cb|e|s|r)\s+[a-z]{1,3}\d[a-z0-9]{2,}(?:\s+[a-z]{2,8})?$/i, '')
      .replace(/\s+s\s+(?:s-)?k\d[a-z0-9]{4,}(?:\s+[a-z]{2,5})?$/i, '')
      .replace(/\s+(?:(?:[3-9]\d{3}|[1-9]\d{4,})[a-z]{0,5})$/i, '')
      .replace(/\s+(?:e5|euro\s*[45]|euro)$/i, '')
      .replace(/\s+(?:clip[- ]?ons?|side\s+mount\s+license(?:\s+plate)?(?:\s+\d+)?|bullet\s+style|mesh\s+brushed|double\s+(?:dyno|gp)|high(?:\s+double\s+gp)?)\b.*$/i, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function cleanVehicleModel(value) {
    const originalModel = String(value || '').replace(/[‐‑‒–—]/g, '-').replace(/\s+/g, ' ').trim();
    const originalSegments = originalModel.split('/');
    const originalSeparators = originalModel.match(/\s*\/\s*/g) || [];
    const cleanedSegments = originalSegments
      .map((segment) => {
        const originalSegment = segment.replace(/\s+/g, ' ').trim();
        return originalSegment
          .replace(/\((?:[^)]*\b(?:abs|non[- ]?abs|base|standard|premium|deluxe|krt edition|icon|full throttle|nightshift|cafe racer|café racer)[^)]*)\)/gi, ' ')
          .replace(/\b(?:non[- ]?abs|without abs|with abs|w\/ ?abs|w\/o ?abs|abs)\b/gi, ' ')
          .replace(/\b(?:krt|anniversary) edition\b/gi, ' ')
          .replace(/\b(?:full throttle|nightshift|cafe racer|café racer|desert sled|icon|urban enduro)\b/gi, ' ')
          .replace(/\b(?:base|standard|std|premium|deluxe)\b/gi, ' ')
          .replace(/\b(?:r-spec)\b/gi, ' ')
          .replace(/\s+/g, ' ')
          .trim();
      })
      .filter(Boolean);
    const uniqueSegments = Array.from(new Set(cleanedSegments));
    const changed = uniqueSegments.length !== originalSegments.length || cleanedSegments.some((segment, index) => segment !== originalSegments[index].replace(/\s+/g, ' ').trim());
    const reconstructed = cleanedSegments.reduce((text, segment, index) => `${text}${index ? originalSeparators[index - 1] || ' / ' : ''}${segment}`, '');

    return (changed ? (uniqueSegments.length === cleanedSegments.length ? reconstructed : uniqueSegments.join(' / ')) : originalModel).replace(/\s*[-/]$/g, '').trim();
  }

  function normalizeVehicleModel(make, model) {
    const rawModelText = normalize(model);
    if (normalize(make).toLowerCase() === 'harley-davidson') {
      const canonicalDisplayModel = HARLEY_DISPLAY_MODELS.get(rawModelText.toLowerCase());
      if (canonicalDisplayModel) return canonicalDisplayModel;
    }
    let modelText = stripSupplierVehicleFragments(rawModelText);
    if (normalize(make).toLowerCase() === 'harley-davidson') {
      const rawHarleyAlias = harleyVehicleModelAlias(rawModelText);
      if (rawHarleyAlias !== null) {
        if (!rawHarleyAlias) return '';
        modelText = rawHarleyAlias;
      }
    }
    if (isHiddenVehicleModel(make, modelText)) return '';
    const aliasedModel = aliasedVehicleModel(make, modelText);
    if (!aliasedModel) return '';
    if (isHiddenVehicleModel(make, aliasedModel)) return '';
    const cleanedModel = cleanVehicleModel(aliasedModel) || aliasedModel;
    return isHiddenVehicleModel(make, cleanedModel) ? '' : cleanedModel;
  }

  function expandedVehicleModels(make, model, year) {
    const makeKey = normalize(make).toLowerCase();
    const rawModelText = normalize(model);
    const modelText = stripSupplierVehicleFragments(model);
    const modelYear = Number(year);

    if (makeKey === 'harley-davidson') {
      const rawHarleyAlias = harleyVehicleModelAlias(rawModelText);
      if (rawHarleyAlias !== null) return rawHarleyAlias ? [rawHarleyAlias] : [];
    }
    if (makeKey === 'aprilia' && /^rsv4\s+rr\s+rsv4\s+rf$/i.test(modelText)) return ['RSV4'];
    if (makeKey === 'aprilia' && /^rsv4\s+tuono\s+v4$/i.test(modelText)) return ['RSV4', 'Tuono V4'];
    if (makeKey === 'bmw' && /^f\s*800\s*gs\s*\/\s*f\s*900\s*gs\s+adventure$/i.test(modelText)) return ['F800 GS', 'F900 GS'];
    if (makeKey === 'bmw' && /^k\s*1600\s+gt\s*\/\s*gtl$/i.test(rawModelText)) return ['K1600 GT', 'K1600 GTL'];
    if (makeKey === 'bmw' && /^k\s*1600\s+gt\s+k\s*1600\s+gtl\b/i.test(rawModelText)) return ['K1600 GT', 'K1600 GTL'];
    if (makeKey === 'bmw' && /^r\s*1200\s+r\s*1200\s+rs$/i.test(rawModelText)) return ['R1200 R', 'R1200 RS'];
    if (makeKey === 'bmw' && /^s\s*1000\s*rr\s+m\s*1000\s*r$/i.test(modelText)) return ['S1000 RR', 'M1000R'];
    if (makeKey === 'ducati' && /^848\s*\/\s*848\s+evo$/i.test(modelText)) return ['848'];
    if (makeKey === 'ducati' && /^v2$/i.test(modelText)) return ['Panigale V2', 'Streetfighter V2'];
    if (makeKey === 'ducati' && /^panigale\s+v2(?:\s+s)?\s+streetfighter\s+v2$/i.test(modelText)) return ['Panigale V2', 'Streetfighter V2'];
    if (makeKey === 'ducati' && /^panigale\s+v4(?:\s+s)?\s+streetfighter\s+v4s?$/i.test(modelText)) return ['Panigale V4', 'Streetfighter V4'];
    if (makeKey === 'ducati' && /^panigale\s+v4(?:\s+s)?\s+streetfighter(?:\s+double)?$/i.test(modelText)) return ['Panigale V4', 'Streetfighter V4'];
    if (makeKey === 'ducati' && /^monster\s+937\s+desertx\s+multistrada\s+v2$/i.test(modelText)) return ['Monster 937', 'DesertX', 'Multistrada V2'];
    if (makeKey === 'ducati' && /^monster\s+937\s+hypermotard\s+698(?:\s+mono)?$/i.test(modelText)) return ['Monster 937', 'Hypermotard 698'];
    if (makeKey === 'ducati' && /^monster\s+937\s+multistrada\s+v2\s+hypermotard$/i.test(modelText)) return ['Monster 937', 'Multistrada V2', 'Hypermotard 698'];
    if (makeKey === 'ducati' && /^monster\s+937\s+panigale$/i.test(modelText)) return ['Monster 937', 'Panigale V2'];
    if (makeKey === 'ducati' && /^hyper\s+821\s+multistrada\s+1200$/i.test(modelText)) return ['Hypermotard 821', 'Multistrada 1200'];
    if (makeKey === 'ducati' && /^monster\s+821\s+1200$/i.test(modelText)) return ['Monster 821', 'Monster 1200'];
    if (makeKey === 'honda' && /^africa\s+twin$/i.test(rawModelText) && Number.isFinite(modelYear)) {
      if (modelYear >= 2020) return ['Africa Twin 1100'];
      if (modelYear >= 2016) return ['Africa Twin 1000'];
    }
    if (makeKey === 'honda' && /^cb[-\s]*1000\s+r\s+cb\s*1000$/i.test(rawModelText)) return ['CB1000R'];
    if (makeKey === 'honda' && /^rebel\s+300\s*\/\s*500$/i.test(modelText)) return ['Rebel 300', 'Rebel 500'];
    if (makeKey === 'husqvarna' && /^vitpilen\s+701\s+svartpilen\s+701(?:\s+euro)?$/i.test(rawModelText)) return ['Vitpilen 701', 'Svartpilen 701'];
    if (makeKey === 'husqvarna' && /^701\s+enduro(?:\s+701)?\s+supermoto(?:\s+55kw)?$/i.test(modelText)) return ['701 Enduro', '701 Supermoto'];
    if (makeKey === 'kawasaki' && /^ninja\s+7\s*\/\s*z7\s+hybrid$/i.test(modelText)) return ['Ninja 7 Hybrid', 'Z7 Hybrid'];
    if (makeKey === 'kawasaki' && /^ninja\s+400\s*\/\s*500$/i.test(modelText)) return Number.isFinite(modelYear) && modelYear < 2024 ? ['Ninja 400'] : ['Ninja 400', 'Ninja 500'];
    if (makeKey === 'kawasaki' && /^ninja\s+1000\s*sx\s*\/\s*1100\s*sx$/i.test(modelText)) return ['Ninja 1000SX', 'Ninja 1100SX'];
    if (makeKey === 'kawasaki' && /^ninja\s+1000\s+sx\s+1100\s+sx$/i.test(modelText)) return ['Ninja 1000SX', 'Ninja 1100SX'];
    if (makeKey === 'kawasaki' && /^versys\s+1000\s+lt\s*\/\s*se\s+lt\+$/i.test(modelText)) return ['Versys 1000'];
    if (makeKey === 'kove' && /^450\s+rally\s+(?:low\s*\/\s*high|low|high)$/i.test(modelText)) return ['450 Rally'];
    if (makeKey === 'ktm' && /^690\s+duke\s*\/\s*r$/i.test(modelText)) return ['690 Duke'];
    if (makeKey === 'ktm' && /^(?:690|700)\s+smc\s+r\s+690\s+enduro$/i.test(modelText)) return ['690 SMC R', '690 Enduro R'];
    if (makeKey === 'ktm' && /^790\s*\/\s*890\s+duke$/i.test(modelText)) return ['790 Duke', '890 Duke'];
    if (makeKey === 'ktm' && /^1190\s+adventure\s*\/\s*(?:adventure\s+)?r$/i.test(modelText)) return ['1190 Adventure'];
    if (makeKey === 'moto morini' && /^seiemmezzo(?:\s+650)?\s+(?:scr\s*\/\s*str|scr|str)$/i.test(modelText)) return ['Seiemmezzo 650'];
    if (makeKey === 'mv agusta' && /^euro5\s+brutale\s+dragster\s+turismo\s+veloce$/i.test(modelText)) return ['Brutale', 'Dragster', 'Turismo Veloce'];
    if (makeKey === 'suzuki' && /^gsx[-\s]*r\s*600\s+gsx\s*r\s*750$/i.test(rawModelText)) return ['GSX-R600', 'GSX-R750'];
    if (makeKey === 'suzuki' && /^gsx[-\s]*r?\s*600\s+1000$/i.test(rawModelText)) return ['GSX-R600', 'GSX-R1000'];
    if (makeKey === 'triumph' && /^speed\s+400\s*\/\s*scrambler\s+400\s+x$/i.test(modelText)) return ['Speed 400', 'Scrambler 400'];
    if (makeKey === 'triumph' && /^speed\s+triple\s+1200\s+rr\s*\/\s*rs$/i.test(modelText)) return ['Speed Triple 1200 RR', 'Speed Triple 1200 RS'];
    if (makeKey === 'yamaha' && /^fjr1300\s*\/\s*fjr1300a\s*\/\s*fjr1300es$/i.test(modelText)) return ['FJR1300'];
    if (makeKey === 'yamaha' && /^tt[-\s]*600\s+xt\s+600\s+tenere$/i.test(modelText)) return ['TT600', 'XT600 Tenere'];

    return [modelText];
  }

  function vehicleModelYearAllowed(make, model, year) {
    const modelYear = Number(year);
    if (!Number.isFinite(modelYear)) return true;
    const key = vehicleModelKey(make, model);
    const minimumYears = new Map([
      ['bmw::f700 gs', 2012],
      ['bmw::m1000 rr', 2021],
      ['bmw::m1000r', 2023],
      ['bmw::m1000xr', 2024],
      ['ducati::streetfighter v4', 2020],
      ['harley-davidson::road glide', 1997],
      ['harley-davidson::street glide', 2006],
      ['honda::africa twin', 2016],
      ['honda::africa twin 1000', 2016],
      ['kawasaki::ninja 500', 2024],
      ['ktm::390 adventure', 2020],
      ['yamaha::r9', 2025],
    ]);
    const maximumYears = new Map([
      ['bmw::r1200 r', 2018],
    ]);
    const minimumYear = minimumYears.get(key);
    const maximumYear = maximumYears.get(key);
    return (!minimumYear || modelYear >= minimumYear) && (!maximumYear || modelYear <= maximumYear);
  }

  function normalizeVehicleModels(make, model, year) {
    return uniqueSorted(
      expandedVehicleModels(make, model, year)
        .map((candidate) => normalizeVehicleModel(make, candidate))
        .filter((candidate) => candidate && vehicleModelYearAllowed(make, candidate, year))
    );
  }

  function liveFitmentKeyForRide(ride) {
    const year = normalize(ride?.year);
    const make = slugifyTagValue(ride?.make);
    const candidates = [
      normalize(ride?.model),
      ...canonicalFitmentTagModels(ride?.make, ride?.model),
      ...fitmentModelVariants(ride?.make, ride?.model),
    ].filter(Boolean);
    const seen = new Set();
    for (const model of candidates) {
      const key = `${year}|${make}|${slugifyTagValue(model)}`;
      if (!year || !make || seen.has(key)) continue;
      seen.add(key);
      if (LIVE_FITMENT_KEYS.has(key)) return key;
    }
    return '';
  }

  function hasLiveStructuredFitment(ride) {
    return Boolean(liveFitmentKeyForRide(ride));
  }

  const vehicleIndex = (() => {
    const byYear = new Map();
    const byYearMake = new Map();
    const byMake = new Map();
    const byMakeModel = new Map();
    const allYears = [];
    const allMakes = [];

    SELECTOR_VEHICLES.forEach((item) => {
      const year = normalize(item.year);
      const make = normalizeVehicleMake(item.make);
      const models = item.fitmentKey
        ? [normalize(item.model)]
        : normalizeVehicleModels(make, item.model, year)
          .filter((model) => hasLiveStructuredFitment({ year, make, model }));
      if (!year || !make || !models.length) return;

      allYears.push(year);
      allMakes.push(make);
      if (!byYear.has(year)) byYear.set(year, []);
      byYear.get(year).push(make);

      models.forEach((model) => {
        const makeKey = `${year}::${make}`;
        if (!byYearMake.has(makeKey)) byYearMake.set(makeKey, []);
        byYearMake.get(makeKey).push(model);

        if (!byMake.has(make)) byMake.set(make, []);
        byMake.get(make).push(model);

        const makeModelKey = `${make}::${model}`;
        if (!byMakeModel.has(makeModelKey)) byMakeModel.set(makeModelKey, []);
        byMakeModel.get(makeModelKey).push(year);
      });
    });

    return {
      years: uniqueSorted(allYears, true),
      makes(year) {
        const selectedYear = normalize(year);
        return uniqueSorted(selectedYear ? byYear.get(selectedYear) || [] : allMakes);
      },
      models(year, make) {
        const selectedYear = normalize(year);
        const selectedMake = normalize(make);
        return uniqueSorted(selectedYear ? byYearMake.get(`${selectedYear}::${selectedMake}`) || [] : byMake.get(selectedMake) || []);
      },
      yearsForRide(make, model) {
        return uniqueSorted(byMakeModel.get(`${normalize(make)}::${normalize(model)}`) || [], true);
      },
    };
  })();

  function fillSelect(select, values, placeholder) {
    if (!select) return;
    const previous = select.value;
    select.innerHTML = '';

    const starter = document.createElement('option');
    starter.value = '';
    starter.textContent = placeholder;
    select.appendChild(starter);

    values.forEach((value) => {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      select.appendChild(option);
    });

    if (previous && values.includes(previous)) {
      select.value = previous;
    }
  }

  function getSavedRide() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    } catch (_error) {
      return {};
    }
  }

  function saveRide(ride) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(ride));
    } catch (_error) {
      return;
    }
  }

  function setPressed(root, value) {
    root.querySelectorAll('[data-p4m-term]').forEach((button) => {
      button.setAttribute('aria-pressed', button.dataset.p4mTerm === value ? 'true' : 'false');
    });
  }

  function buildQuery(parts) {
    return parts.map(normalize).filter(Boolean).join(' ');
  }

  function quoteSearchPhrase(value) {
    const phrase = normalize(value).replace(/"/g, '').replace(/\s+/g, ' ');
    if (!phrase) return '';
    return /\s/.test(phrase) ? `"${phrase}"` : phrase;
  }

  function escapeRegExp(value) {
    return String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function hasSelectValue(select, value) {
    return Array.from(select?.options || []).some((option) => option.value === value);
  }

  function slugifyTagValue(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');
  }

  const FITMENT_METAFIELD_NAMESPACE = 'app--306803113985';
  const FITMENT_METAFIELD_KEYS = ['fitment_vehicles_1', 'fitment_vehicles_2'];

  function fitmentMetaobjectRegistryKey({ year, make, model }) {
    const normalizedYear = normalize(year);
    const normalizedMake = slugifyTagValue(make);
    const normalizedModel = slugifyTagValue(model);
    if (!normalizedYear || !normalizedMake || !normalizedModel) return '';
    return `${normalizedYear}|${normalizedMake}|${normalizedModel}`;
  }

  function fitmentMetaobjectMatchForRide(ride) {
    const index = window.P4M_FITMENT_METAOBJECT_REGISTRY?.index;
    if (!index || typeof index !== 'object') return null;

    const candidates = [
      normalize(ride?.model),
      ...canonicalFitmentTagModels(ride?.make, ride?.model),
      ...fitmentModelVariants(ride?.make, ride?.model),
    ].filter(Boolean);
    const seen = new Set();
    for (const model of candidates) {
      const key = fitmentMetaobjectRegistryKey({ ...ride, model });
      if (!key || seen.has(key)) continue;
      seen.add(key);
      if (index[key] && LIVE_FITMENT_KEYS.has(key)) return { id: index[key], key };
    }
    return null;
  }

  function fitmentMetaobjectForRide(ride) {
    return fitmentMetaobjectMatchForRide(ride)?.id || '';
  }

  function fitmentFilterParam(key) {
    return `filter.v.m.${FITMENT_METAFIELD_NAMESPACE}.${key}`;
  }

  function fitmentTagForRide({ year, make, model }) {
    const tagYear = normalize(year);
    const tagMake = slugifyTagValue(make);
    const tagModel = slugifyTagValue(model);
    if (!tagYear || !tagMake || !tagModel) return '';
    return `p4m_fitment_${tagMake}_${tagModel}_${tagYear}`;
  }

  function fitmentTagSearchTerm(ride) {
    const tag = fitmentTagForRide(ride);
    return tag ? `tag:${tag}` : '';
  }

  function canonicalFitmentTagModels(make, model) {
    const makeKey = normalize(make).toLowerCase();
    const modelKey = normalize(model).toUpperCase().replace(/\s+/g, '');
    if (makeKey === 'kawasaki' && (modelKey === 'ZX-6R' || modelKey === 'ZX6R' || modelKey === 'ZX636' || modelKey === 'NINJAZX-6R' || modelKey === 'NINJAZX6R')) {
      return ['ZX-6R', 'Ninja ZX-6R', 'ZX-6R 636', 'ZX636 Ninja ZX-6R'];
    }
    return [];
  }

  function normalizeFitmentToken(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isTrimSearchToken(word) {
    return trimNoiseTokens.has(normalizeFitmentToken(word));
  }

  function fitmentTokenContains(source, term) {
    const sourceToken = ` ${normalizeFitmentToken(source)} `;
    const termToken = normalizeFitmentToken(term);
    return termToken ? sourceToken.includes(` ${termToken} `) : false;
  }

  function editDistanceAtMostOne(left, right) {
    if (left === right) return true;
    if (Math.abs(left.length - right.length) > 1) return false;
    let mismatches = 0;
    let i = 0;
    let j = 0;
    while (i < left.length && j < right.length) {
      if (left[i] === right[j]) {
        i += 1;
        j += 1;
        continue;
      }
      mismatches += 1;
      if (mismatches > 1) return false;
      if (left.length > right.length) i += 1;
      else if (right.length > left.length) j += 1;
      else {
        i += 1;
        j += 1;
      }
    }
    return true;
  }

  function fitmentWordMatches(sourceWord, targetWord) {
    if (!sourceWord || !targetWord) return false;
    if (sourceWord === targetWord) return true;
    if (/\d/.test(sourceWord) || /\d/.test(targetWord)) return false;
    return targetWord.length >= 5 && sourceWord.length >= 4 && editDistanceAtMostOne(sourceWord, targetWord);
  }

  function fitmentTokenContainsFuzzy(source, term) {
    if (fitmentTokenContains(source, term)) return true;
    const sourceWords = normalizeFitmentToken(source).split(/\s+/).filter(Boolean);
    const termWords = normalizeFitmentToken(term).split(/\s+/).filter(Boolean);
    if (!sourceWords.length || !termWords.length) return false;

    let sourceIndex = 0;
    for (const termWord of termWords) {
      let matched = false;
      while (sourceIndex < sourceWords.length) {
        if (fitmentWordMatches(sourceWords[sourceIndex], termWord)) {
          matched = true;
          sourceIndex += 1;
          break;
        }
        sourceIndex += 1;
      }
      if (!matched) return false;
    }
    return true;
  }

  function compactFitmentToken(value) {
    return normalizeFitmentToken(value).replace(/\s+/g, '');
  }

  function isCategorySearchToken(word) {
    return /^(?:exhaust|exhausts|muffler|mufflers|silencer|silencers|header|headers|pipe|pipes|slip|tire|tires|tyre|tyres|helmet|helmets|jacket|jackets|glove|gloves|boot|boots|apparel|gear|pants|shirt|jersey|goggle|goggles|oil|filter|filters|battery|batteries|accessory|accessories|luggage|grip|grips|phone|mount|quad|lock|sp|connect|fuel|gas|tank|cap|caps|locking)$/i.test(word);
  }

  function modelMatchFromSearchQuery(query, model) {
    if (fitmentTokenContainsFuzzy(query, model)) {
      return { matched: true, exact: true, hint: normalizeFitmentToken(model) };
    }

    const modelCompact = compactFitmentToken(model);
    const sourceWords = normalizeFitmentToken(query)
      .split(/\s+/)
      .filter((word) => word && !isTrimSearchToken(word) && !isCategorySearchToken(word));
    const hints = [];
    for (let index = 0; index < sourceWords.length; index += 1) {
      let compactPhrase = '';
      for (let end = index; end < Math.min(sourceWords.length, index + 5); end += 1) {
        compactPhrase += compactFitmentToken(sourceWords[end]);
        if (!compactPhrase || compactPhrase.length < 3) continue;
        if (compactPhrase === modelCompact) {
          return { matched: true, exact: true, hint: normalizeFitmentToken(model) };
        }
        if (!/\d/.test(compactPhrase) && compactPhrase.length < 5) continue;
        if (modelCompact.startsWith(compactPhrase)) hints.push(compactPhrase);
      }
    }

    if (!hints.length) return { matched: false, exact: false, hint: '' };
    hints.sort((a, b) => b.length - a.length);
    return { matched: true, exact: false, hint: hints[0] };
  }

  function modelCodeSet(model) {
    const codes = new Set();
    String(model || '')
      .split(/[/,;]|\bor\b|\band\b/i)
      .forEach((segment) => {
        const words = normalizeFitmentToken(segment).split(/\s+/).filter(Boolean);
        for (let index = 0; index < words.length; index += 1) {
          let compactPhrase = '';
          for (let end = index; end < Math.min(words.length, index + 4); end += 1) {
            compactPhrase += compactFitmentToken(words[end]);
            if (compactPhrase.length >= 4 && /[a-z]/.test(compactPhrase) && /\d/.test(compactPhrase)) {
              codes.add(compactPhrase);
            }
          }
        }
      });
    return codes;
  }

  function hasLongerTrailingModelCode(codes, sharedCode) {
    return Array.from(codes).some((code) => code !== sharedCode && code.startsWith(sharedCode));
  }

  function modelsShareExactCode(leftModel, rightModel) {
    const leftCodes = modelCodeSet(leftModel);
    const rightCodes = modelCodeSet(rightModel);
    for (const code of leftCodes) {
      if (!rightCodes.has(code)) continue;
      if (hasLongerTrailingModelCode(leftCodes, code) || hasLongerTrailingModelCode(rightCodes, code)) continue;
      return true;
    }
    return false;
  }

  const rideSearchIndex = (() => {
    const seen = new Set();
    const rides = [];

    SELECTOR_VEHICLES.forEach((item) => {
      const year = normalize(item.year);
      const make = normalizeVehicleMake(item.make);
      const models = item.fitmentKey
        ? [normalize(item.model)]
        : normalizeVehicleModels(make, item.model, year)
          .filter((model) => hasLiveStructuredFitment({ year, make, model }));
      if (!year || !make || !models.length) return;

      models.forEach((model) => {
        const key = `${year}::${make}::${model}`;
        if (seen.has(key)) return;
        seen.add(key);
        rides.push({
          year,
          make,
          model,
          makeToken: normalizeFitmentToken(make),
          modelToken: normalizeFitmentToken(model),
        });
      });
    });

    return rides.sort((a, b) => b.modelToken.length - a.modelToken.length);
  })();

  const rideTagIndex = (() => {
    const seen = new Set();
    const rides = [];

    const sourceRows = LIVE_FITMENT_RIDES.length
      ? [...SELECTOR_VEHICLES, ...VEHICLES]
      : VEHICLES;
    sourceRows.forEach((item) => {
      const year = normalize(item.year);
      const make = normalizeVehicleMake(item.make);
      const models = item.fitmentKey
        ? [normalize(item.model)]
        : normalizeVehicleModels(make, item.model, year)
          .filter((model) => hasLiveStructuredFitment({ year, make, model }));
      const tagModels = (Array.isArray(item.tagModels) ? item.tagModels : [item.model]).map(normalize).filter(Boolean);
      if (!year || !make || !models.length || !tagModels.length) return;

      models.forEach((model) => {
        tagModels.forEach((tagModel) => {
          const key = `${year}::${make}::${model}::${tagModel}`;
          if (seen.has(key)) return;
          seen.add(key);
          rides.push({
            year,
            make,
            model,
            tagModel,
          });
        });
      });
    });

    return rides;
  })();

  const rideFamilyIndex = (() => {
    const byKey = new Map();
    rideSearchIndex.forEach((ride) => {
      const key = `${ride.make}::${ride.model}`;
      if (!byKey.has(key)) {
        byKey.set(key, {
          make: ride.make,
          model: ride.model,
          makeToken: ride.makeToken,
          modelToken: ride.modelToken,
          years: [],
        });
      }
      byKey.get(key).years.push(ride.year);
    });
    return [...byKey.values()].sort((a, b) => b.modelToken.length - a.modelToken.length);
  })();

  function fitmentTagSearchTermsForRide(ride) {
    const selectedYear = normalize(ride.year);
    const selectedMake = normalize(ride.make);
    const selectedModel = normalize(ride.model);
    const canonicalTagModels = canonicalFitmentTagModels(selectedMake, selectedModel);
    const canonicalTerms = selectedYear && selectedMake
      ? canonicalTagModels.map((model) => fitmentTagSearchTerm({ year: selectedYear, make: selectedMake, model }))
      : [];

    const aliases = rideTagIndex.filter((candidate) => {
      if (candidate.year !== selectedYear || candidate.make !== selectedMake) return false;
      return candidate.model === selectedModel || modelsShareExactCode(selectedModel, candidate.model);
    });
    const aliasPool = aliases.length ? aliases : [{ year: selectedYear, make: selectedMake, model: selectedModel, tagModel: selectedModel }];
    aliasPool.sort((left, right) => Number(right.model === selectedModel) - Number(left.model === selectedModel) || left.tagModel.localeCompare(right.tagModel));
    const seen = new Set();
    return [
      ...canonicalTerms,
      ...aliasPool.flatMap((alias) => [alias.model, alias.tagModel, ...fitmentModelVariants(alias.make, alias.model), ...fitmentModelVariants(alias.make, alias.tagModel)].map((model) => fitmentTagSearchTerm({ ...alias, model }))),
    ]
      .filter((term) => {
        if (!term || seen.has(term)) return false;
        seen.add(term);
        return true;
      });
  }

  function fitmentModelVariants(make, model) {
    const variants = [normalize(model)];
    const makeKey = normalize(make).toLowerCase();
    const modelKey = normalize(model).toUpperCase().replace(/\s+/g, '');

    if (makeKey === 'harley-davidson') {
      const pushVariants = (values) => values.forEach((variant) => variants.push(variant));
      const softailCodeLabels = [
        'Softail 6043',
        'Softail 6223',
        'Softail 6224',
        'Softail 6225',
        'Softail 6225B',
        'Softail 6420',
        'Softail 6421',
        'Softail 6422',
        'Softail 6483',
        'Softail 6483B',
        'Softail 6484',
        'Softail 6485',
        'Softail 6485B',
        'Softail 6711B',
        'Softail 6712',
        'Softail 6712B',
        'Softail 6810T',
        'Softail 6811T',
        'Softail 6850',
        'Softail 6852',
        'Softail 6852B',
        'Softail 6853',
        'Softail 6853B',
        'Softail 6950T',
        'Softail 6951T',
        'Softail 6952T',
        'Softail 6987',
        'Softail 6988',
        'Softail 6989',
      ];
      const sportsterCodeLabels = [
        'Sportster Xl 6030',
        'Sportster Xl 6030RB',
        'Sportster Xl 6036',
        'Sportster Xl 6233',
        'Sportster Xl 6233B',
        'Sportster Xl 6701',
        'Sportster Xl 6701B',
        'Sportster Xl 6704',
        'Sportster Xl 6704B',
        'Sportster Xl 6882',
      ];

      if (modelKey === 'BREAKOUT') {
        pushVariants([
          'FXSB Breakout',
          'FXSE Breakout',
          'CVO Pro Street Breakout',
          'Softail Pro Street Breakout',
          'CVO Softail Pro Street Breakout',
          'FXBR Breakout',
          'FXBRS Breakout S',
          'Softail 6422',
          'Softail 6952T',
        ]);
      }
      if (modelKey === 'FATBOY') {
        pushVariants(['Fat Boy Flstf 6000', 'Fat Boy Flstf 6001', 'FLFBS Fat Boy 114', 'FLSTF Fat Boy']);
      }
      if (modelKey === 'HERITAGECLASSIC' || modelKey === 'HERITAGESOFTAILCLASSIC') {
        pushVariants(['FLHCS Heritage Classic 114', 'FLSTC Heritage Softail Classic', 'FLHC Heritage Classic']);
      }
      if (modelKey === 'STREETBOB') {
        pushVariants(['FXBBS Street Bob 114']);
      }
      if (modelKey === 'FATBOB') {
        pushVariants(['FXFBS Fat Bob 114']);
      }
      if (modelKey === 'STREETROD') {
        pushVariants(['Street Rod XG750A']);
      }
      if (modelKey === 'SOFTAIL') {
        pushVariants(softailCodeLabels);
      }
      if (modelKey === 'SPORTSTERXL') {
        pushVariants(sportsterCodeLabels);
      }
    }

    if (makeKey === 'yamaha') {
      const yamahaSportAliases = {
        R1: ['YZF-R1', 'YZF R1', 'R1M', 'YZF-R1M', 'R1S', 'YZF-R1S'],
        R3: ['YZF-R3', 'YZF R3'],
        R6: ['YZF-R6', 'YZF R6'],
        R7: ['YZF-R7', 'YZF R7'],
        R9: ['YZF-R9', 'YZF R9'],
      };
      (yamahaSportAliases[modelKey] || []).forEach((variant) => variants.push(variant));
    }

    if (makeKey === 'kawasaki' && (modelKey === 'ZX-6R' || modelKey === 'ZX6R' || modelKey === 'ZX636' || modelKey === 'NINJAZX-6R' || modelKey === 'NINJAZX6R')) {
      [
        'ZX-6R',
        'ZX6R',
        'ZX-6R 636',
        'ZX636',
        'Ninja ZX-6R',
        'Ninja Zx 6R',
        'ZX636 Ninja ZX-6R',
      ].forEach((variant) => variants.push(variant));
    }

    String(model || '')
      .split(/[/,;]|\bor\b|\band\b/i)
      .map(normalize)
      .filter(Boolean)
      .forEach((variant) => variants.push(variant));
    return Array.from(new Set(variants));
  }

  function fitmentTagSearchExpression(ride) {
    const tagTerms = fitmentTagSearchTermsForRide(ride);
    const structuredTagHandles = window.P4M_STRUCTURED_FITMENT_INDEX?.tagHandles;
    const structuredHandles = new Set();
    if (structuredTagHandles && typeof structuredTagHandles === 'object') {
      tagTerms.forEach((term) => {
        const tag = term.replace(/^tag:/, '');
        const handles = structuredTagHandles[tag];
        if (!Array.isArray(handles)) return;
        handles.forEach((handle) => {
          if (/^[a-z0-9][a-z0-9®™-]*$/i.test(handle)) structuredHandles.add(handle);
        });
      });
    }
    const terms = [
      ...tagTerms,
      ...Array.from(structuredHandles).sort().map((handle) => `handle:${handle}`),
    ];
    if (terms.length <= 1) return terms[0] || '';
    return `(${terms.join(' OR ')})`;
  }

  function removeRideWords(rawQuery, ride, year) {
    const modelWords = ride.modelToken.split(/\s+/).filter(Boolean);
    const makeWords = ride.makeToken.split(/\s+/).filter(Boolean);
    const words = normalizeFitmentToken(rawQuery).split(/\s+/).filter(Boolean);
    const modelCompact = compactFitmentToken(ride.modelToken);
    const removeIndexes = new Set();
    for (let index = 0; index < words.length; index += 1) {
      let compactPhrase = '';
      for (let end = index; end < Math.min(words.length, index + 5); end += 1) {
        if (words[end] === year || isTrimSearchToken(words[end])) break;
        compactPhrase += compactFitmentToken(words[end]);
        if (!compactPhrase || compactPhrase.length < 3) continue;
        const isModelPhrase = compactPhrase === modelCompact || (modelCompact.startsWith(compactPhrase) && (/\d/.test(compactPhrase) || compactPhrase.length >= 5));
        if (!isModelPhrase) continue;
        for (let removeIndex = index; removeIndex <= end; removeIndex += 1) removeIndexes.add(removeIndex);
      }
    }
    return normalizeFitmentToken(rawQuery)
      .split(/\s+/)
      .filter((word, index) => {
        if (removeIndexes.has(index)) return false;
        if (!word || word === year || isTrimSearchToken(word)) return false;
        if (modelWords.some((modelWord) => fitmentWordMatches(word, modelWord))) return false;
        if (makeWords.some((makeWord) => fitmentWordMatches(word, makeWord))) return false;
        return true;
      })
      .join(' ')
      .trim();
  }

  function isSpecificModelOnlyCandidate(ride, allCandidates) {
    const sameModelMatches = allCandidates.filter((candidate) => candidate.modelToken === ride.modelToken);
    if (sameModelMatches.length !== 1) return false;
    const modelWords = ride.modelToken.split(/\s+/).filter(Boolean);
    if (modelWords.length >= 2) return true;
    return ride.modelToken.length >= 6 && /\d/.test(ride.modelToken);
  }

  function isUniqueModelCandidate(ride, allCandidates) {
    return allCandidates.filter((candidate) => candidate.modelToken === ride.modelToken).length === 1;
  }

  function commonMake(candidates) {
    const makes = Array.from(new Set(candidates.map((candidate) => candidate.make)));
    return makes.length === 1 ? makes[0] : '';
  }

  function commonModelHint(candidates) {
    const hints = candidates.map((candidate) => candidate.modelMatch?.hint || '').filter(Boolean);
    if (!hints.length) return '';
    return hints.sort((a, b) => a.length - b.length)[0];
  }

  function categoryFromSearchWords(words) {
    const text = normalizeFitmentToken(words);
    if (!text) return '';
    if (/\b(exhaust|muffler|silencer|header|headers|pipe|pipes|slip on|slip)\b/.test(text)) return 'exhaust';
    if (/\b(tire|tires|tyre|tyres)\b/.test(text)) return 'tire';
    if (/\b(helmet|jacket|glove|gloves|boot|boots|apparel|riding gear|pants|shirt|jersey|goggle|goggles)\b/.test(text)) return 'helmet jacket glove boot apparel riding gear';
    if (/\b(oil|filter|brake fluid|chain lube|coolant|cleaner|maintenance|battery|spark plug)\b/.test(text)) return 'oil filter brake fluid chain lube coolant cleaner maintenance battery';
    if (/\b(?:fuel|gas)\b.*\b(?:tank|cap|caps|locking)\b|\b(?:tank|cap|caps|locking)\b.*\b(?:fuel|gas)\b|\btank cap\b|\bfuel cap\b|\bgas cap\b/.test(text)) return 'fuel tank cap gas cap accessories';
    if (/\b(accessory|accessories|luggage|grip|grips|phone|mount|quad lock|quadlock|sp connect)\b/.test(text)) return 'accessories luggage grips universal phone mount quad lock sp connect';
    return '';
  }

  function categoryFromSearchContext(remainingWords, rawQuery) {
    return categoryFromSearchWords(remainingWords) || categoryFromSearchWords(rawQuery);
  }

  function shouldStayTextProductSearch(intent) {
    if (!intent || !intent.category) return false;
    const category = normalizeFitmentToken(intent.category);
    const remaining = normalizeFitmentToken(intent.remainingWords);
    const productText = `${remaining} ${category}`;
    return /\b(?:fuel|gas|tank|cap|caps|locking)\b/.test(productText);
  }

  function bikeIntentFromSearchQuery(query) {
    const rawQuery = normalize(query).replace(/\s+/g, ' ');
    if (!rawQuery || /[*:]/.test(rawQuery) || /\s-\S/.test(rawQuery) || /\bNOT\b/i.test(rawQuery)) return { type: 'none' };

    const year = rawQuery.match(/\b(?:19|20)\d{2}\b/)?.[0] || '';
    if (year) {
      const candidates = rideSearchIndex
        .map((ride) => ({ ...ride, modelMatch: modelMatchFromSearchQuery(rawQuery, ride.model) }))
        .filter((ride) => ride.year === year && ride.modelMatch.matched)
        .map((ride) => ({
          ...ride,
          makeMatched: fitmentTokenContains(rawQuery, ride.make),
          remainingWords: removeRideWords(rawQuery, ride, year),
        }));
      if (!candidates.length) return { type: 'none' };

      const strongCandidates = candidates.filter((ride) => ride.makeMatched);
      const searchPool = strongCandidates.length ? strongCandidates : candidates;
      const exactPool = searchPool.filter((ride) => ride.modelMatch.exact);
      const uniqueModelCandidates = exactPool.filter((candidate, _index, all) => isUniqueModelCandidate(candidate, all));
      if (!uniqueModelCandidates.length) {
        const make = commonMake(searchPool);
        if (!make) return { type: 'none' };
        return {
          type: 'needs_model',
          year,
          make,
          modelHint: commonModelHint(searchPool),
          remainingWords: searchPool[0].remainingWords,
          category: categoryFromSearchContext(searchPool[0].remainingWords, rawQuery),
        };
      }

      uniqueModelCandidates.sort((a, b) => Number(b.makeMatched) - Number(a.makeMatched) || b.modelToken.length - a.modelToken.length);
      const ride = uniqueModelCandidates[0];
      return {
        type: 'exact',
        year,
        make: ride.make,
        model: ride.model,
        remainingWords: ride.remainingWords,
        category: categoryFromSearchContext(ride.remainingWords, rawQuery),
      };
    }

    const candidates = rideFamilyIndex
      .map((ride) => ({ ...ride, modelMatch: modelMatchFromSearchQuery(rawQuery, ride.model) }))
      .filter((ride) => ride.modelMatch.matched)
      .map((ride) => ({
        ...ride,
        makeMatched: fitmentTokenContains(rawQuery, ride.make),
        remainingWords: removeRideWords(rawQuery, ride, ''),
      }));

    if (!candidates.length) return { type: 'none' };
    const strongCandidates = candidates.filter((ride) => ride.makeMatched);
    const searchPool = strongCandidates.length ? strongCandidates : candidates;
    const exactPool = searchPool.filter((ride) => ride.modelMatch.exact);
    const uniqueModelCandidates = exactPool.filter((candidate, _index, all) => isSpecificModelOnlyCandidate(candidate, all));
    if (!uniqueModelCandidates.length) {
      const make = commonMake(searchPool);
      const modelHint = commonModelHint(searchPool);
      const category = categoryFromSearchContext(searchPool[0].remainingWords, rawQuery);
      if (!strongCandidates.length && category) return { type: 'none' };
      if (!make || !modelHint) return { type: 'none' };
      return {
        type: 'needs_model',
        make,
        modelHint,
        remainingWords: searchPool[0].remainingWords,
        category,
      };
    }

    uniqueModelCandidates.sort((a, b) => Number(b.makeMatched) - Number(a.makeMatched) || b.modelToken.length - a.modelToken.length);
    const ride = uniqueModelCandidates[0];
    return {
      type: 'needs_year',
      make: ride.make,
      model: ride.model,
      remainingWords: ride.remainingWords,
      category: categoryFromSearchContext(ride.remainingWords, rawQuery),
    };
  }

  function rideFromSearchQuery(query) {
    const rawQuery = normalize(query).replace(/\s+/g, ' ');
    const yearMatch = rawQuery.match(/\b(?:19|20)\d{2}\b/);
    if (!yearMatch) return null;

    const year = yearMatch[0];
    const candidates = rideSearchIndex
      .filter((ride) => ride.year === year && fitmentTokenContains(rawQuery, ride.model))
      .map((ride) => ({
        ...ride,
        makeMatched: fitmentTokenContains(rawQuery, ride.make),
      }))
      .filter((ride) => ride.makeMatched || ride.modelToken.split(' ').length > 1);

    if (!candidates.length) return null;
    candidates.sort((a, b) => Number(b.makeMatched) - Number(a.makeMatched) || b.modelToken.length - a.modelToken.length);
    return candidates[0];
  }

  function buildFitmentQuery({ keyword, year, make, model, category }) {
    // Every complete selector submission must enter the structured results
    // route. An unindexed ride then renders an explicit zero-result state
    // instead of reloading the same Shop by Bike form with no explanation.
    if (year && make && model) return 'p4m-fitment-index';
    return buildQuery([keyword, category]) || '*';
  }

  function strictFitmentQuery(query) {
    const rawQuery = normalize(query).replace(/\s+/g, ' ');
    if (!rawQuery) return '';
    if (/[*:]/.test(rawQuery) || /\s-\S/.test(rawQuery) || /\bNOT\b/i.test(rawQuery)) return rawQuery;

    const intent = bikeIntentFromSearchQuery(rawQuery);
    if (intent.type !== 'exact') return rawQuery;
    if (shouldStayTextProductSearch(intent)) return rawQuery;

    return buildQuery([intent.remainingWords, intent.category]) || '*';
  }

  function redirectLooseFitmentSearch() {
    if (window.location.pathname !== '/search') return;

    const params = new URLSearchParams(window.location.search);
    const query = params.get('q') || '';
    if (params.get('p4m_quick') === '1') return;
    // An explicit product search must not silently become a vehicle-fitment
    // search (or lose its selected product keyword family) after refresh.
    if (params.get('p4m_product_search') === '1' || (params.get('category') && !params.get('year') && !params.get('make') && !params.get('model'))) return;

    const intent = bikeIntentFromSearchQuery(query);
    if (intent.type === 'needs_year' || intent.type === 'needs_model') {
      if (intent.category) return;

      const target = new URLSearchParams();
      target.set('make', intent.make);
      if (intent.year) target.set('year', intent.year);
      if (intent.model) target.set('model', intent.model);
      if (intent.modelHint) target.set('model_hint', intent.modelHint);
      if (intent.category) target.set('category', intent.category);
      window.location.replace(`/pages/shop-by-bike?${target.toString()}`);
      return;
    }

    if (intent.type === 'exact') {
      const target = searchUrlFromExactBikeIntent(intent);
      if (target !== `${window.location.pathname}${window.location.search}`) {
        window.location.replace(target);
      }
    }
  }

  function headerSearchParams(query) {
    const params = new URLSearchParams();
    params.set('type', 'product');
    params.set('options[prefix]', 'last');
    params.set('options[fields]', 'title,body,tag,product_type,vendor,variants.sku,variants.title');
    params.set('q', query);
    return params;
  }

  function shopByBikeUrlFromIntent(intent) {
    const target = new URLSearchParams();
    if (intent.year) target.set('year', intent.year);
    if (intent.make) target.set('make', intent.make);
    if (intent.model) target.set('model', intent.model);
    if (intent.modelHint) target.set('model_hint', intent.modelHint);
    if (intent.category) target.set('category', intent.category);
    return `/pages/shop-by-bike?${target.toString()}`;
  }

  function searchUrlFromExactBikeIntent(intent) {
    const vehicle = fitmentMetaobjectMatchForRide(intent);
    if (!vehicle) return shopByBikeUrlFromIntent(intent);

    const params = headerSearchParams('p4m-fitment-index');
    params.set('year', intent.year);
    params.set('make', intent.make);
    params.set('model', intent.model);
    if (intent.category) params.set('category', intent.category);
    if (intent.remainingWords) params.set('p4m_keyword', intent.remainingWords);
    params.set('p4m_fitment', 'metaobject');
    params.set('p4m_vehicle', vehicle.id);
    params.set('p4m_lookup', vehicle.key);
    return `/search?${params.toString()}`;
  }

  function categoryLabel(category) {
    const categoryText = normalizeFitmentToken(category);
    if (!categoryText) return 'parts';
    if (categoryText.includes('exhaust')) return 'exhausts';
    if (categoryText.includes('tire')) return 'tires';
    if (categoryText.includes('helmet') || categoryText.includes('apparel')) return 'rider gear';
    if (categoryText.includes('oil') || categoryText.includes('maintenance')) return 'maintenance';
    if (categoryText.includes('accessories')) return 'accessories';
    return 'parts';
  }

  function headerVehicleSuggestion(query) {
    const intent = bikeIntentFromSearchQuery(query);
    if (intent.type === 'exact') {
      return {
        type: 'vehicle',
        label: buildQuery([intent.year, intent.make, intent.model]),
        detail: `Shop ${categoryLabel(intent.category)} that fit this bike`,
        action: 'Shop fitment',
        href: searchUrlFromExactBikeIntent(intent),
      };
    }

    if (intent.type === 'needs_year') {
      const years = vehicleIndex.yearsForRide(intent.make, intent.model).slice(0, 4).join(', ');
      return {
        type: 'vehicle',
        label: buildQuery([intent.make, intent.model]),
        detail: years ? `Choose year, including ${years}` : 'Choose year to search fitment',
        action: 'Choose year',
        href: shopByBikeUrlFromIntent(intent),
      };
    }

    if (intent.type === 'needs_model') {
      return {
        type: 'vehicle',
        label: buildQuery([intent.year, intent.make, intent.modelHint && intent.modelHint.toUpperCase()]),
        detail: 'Choose the exact model to search fitment',
        action: 'Choose model',
        href: shopByBikeUrlFromIntent(intent),
      };
    }

    return null;
  }

  function normalizeHeaderSearchQuery(query) {
    if (window.P4MSearch && typeof window.P4MSearch.normalize === 'function') {
      return window.P4MSearch.normalize(query);
    }
    return normalize(query);
  }

  function safeSuggestionUrl(url, fallbackQuery) {
    try {
      const parsed = new URL(url || '', window.location.origin);
      if (parsed.origin === window.location.origin) {
        return `${parsed.pathname}${parsed.search}${parsed.hash}`;
      }
    } catch (_error) {
      return `/search?${headerSearchParams(fallbackQuery).toString()}`;
    }
    return `/search?${headerSearchParams(fallbackQuery).toString()}`;
  }

  function productImageUrl(product) {
    return product?.featured_image?.url || product?.image || '';
  }

  function formatPredictivePrice(product) {
    const price = Number(product?.price_min || product?.price || 0);
    if (!Number.isFinite(price) || price <= 0) return '';
    return `$${price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }

  function debounce(callback, delay) {
    let timer = 0;
    return (...args) => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => callback(...args), delay);
    };
  }

  async function fetchPredictiveSearch(query, signal) {
    const params = new URLSearchParams();
    params.set('q', query);
    params.set('resources[type]', 'product,query,collection');
    params.set('resources[limit]', '6');
    params.set('resources[limit_scope]', 'all');
    params.set('resources[options][unavailable_products]', 'last');
    params.set('resources[options][fields]', 'title,product_type,variants.title,vendor,variants.sku');

    const response = await fetch(`/search/suggest.json?${params.toString()}`, {
      signal,
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error(`Predictive search failed: ${response.status}`);
    return response.json();
  }

  function textNode(tagName, className, text) {
    const element = document.createElement(tagName);
    if (className) element.className = className;
    element.textContent = text || '';
    return element;
  }

  function createSuggestionItem(item, index) {
    const link = document.createElement('a');
    link.className = `p4m-header-search-suggest__item${item.type === 'vehicle' ? ' p4m-header-search-suggest__item--vehicle' : ''}`;
    link.href = item.href;
    link.id = `P4MHeaderSearchSuggestItem-${index}`;
    link.setAttribute('role', 'option');
    link.setAttribute('data-p4m-suggest-item', '');

    const media = document.createElement('span');
    media.className = 'p4m-header-search-suggest__media';
    media.setAttribute('aria-hidden', 'true');
    if (item.image) {
      const image = document.createElement('img');
      image.src = item.image;
      image.alt = '';
      image.loading = 'lazy';
      media.appendChild(image);
    } else {
      media.textContent = item.type === 'vehicle' ? 'Bike' : 'P4M';
    }

    const body = document.createElement('span');
    body.className = 'p4m-header-search-suggest__body';
    body.appendChild(textNode('span', 'p4m-header-search-suggest__title', item.label));
    body.appendChild(textNode('span', 'p4m-header-search-suggest__meta', item.detail));

    link.appendChild(media);
    link.appendChild(body);
    link.appendChild(textNode('span', item.type === 'vehicle' ? 'p4m-header-search-suggest__action' : 'p4m-header-search-suggest__price', item.action || item.price));
    return link;
  }

  function renderSuggestionSection(panel, label, items, startIndex) {
    if (!items.length) return startIndex;

    const section = document.createElement('div');
    section.className = 'p4m-header-search-suggest__section';
    section.appendChild(textNode('p', 'p4m-header-search-suggest__label', label));
    items.forEach((item, offset) => section.appendChild(createSuggestionItem(item, startIndex + offset)));
    panel.appendChild(section);
    return startIndex + items.length;
  }

  function initHeaderSearchAutocomplete() {
    document.querySelectorAll('.p4m-header-search__form').forEach((form, formIndex) => {
      if (form.dataset.p4mSuggestReady === 'true') return;
      const input = form.querySelector('.p4m-header-search__input');
      if (!(input instanceof HTMLInputElement)) return;

      form.dataset.p4mSuggestReady = 'true';
      const panel = document.createElement('div');
      panel.className = 'p4m-header-search-suggest';
      panel.id = `P4MHeaderSearchSuggest-${formIndex}`;
      panel.setAttribute('role', 'listbox');
      panel.hidden = true;
      form.parentElement?.appendChild(panel);

      input.setAttribute('aria-autocomplete', 'list');
      input.setAttribute('aria-expanded', 'false');
      input.setAttribute('aria-controls', panel.id);

      let requestId = 0;
      let activeIndex = -1;
      let controller = null;

      const close = () => {
        panel.hidden = true;
        panel.innerHTML = '';
        activeIndex = -1;
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
      };

      const setActive = (index) => {
        const options = Array.from(panel.querySelectorAll('[data-p4m-suggest-item]'));
        if (!options.length) return;
        activeIndex = (index + options.length) % options.length;
        options.forEach((option, optionIndex) => {
          option.classList.toggle('is-active', optionIndex === activeIndex);
        });
        input.setAttribute('aria-activedescendant', options[activeIndex].id);
      };

      const render = (query, vehicleItem, predictiveResults) => {
        panel.innerHTML = '';
        const products = (predictiveResults?.resources?.results?.products || []).slice(0, 5).map((product) => ({
          type: 'product',
          label: product.title || 'Product',
          detail: buildQuery([product.vendor, product.type || product.product_type, product.available === false ? 'Sold out' : '']),
          price: formatPredictivePrice(product),
          image: productImageUrl(product),
          href: safeSuggestionUrl(product.url, query),
        }));
        const queryItems = (predictiveResults?.resources?.results?.queries || []).slice(0, 2).map((item) => ({
          type: 'query',
          label: item.text || query,
          detail: 'Suggested search',
          action: 'Search',
          href: safeSuggestionUrl(item.url, query),
        }));

        let index = 0;
        index = renderSuggestionSection(panel, 'Vehicle fitment', vehicleItem ? [vehicleItem] : [], index);
        index = renderSuggestionSection(panel, 'Products', products, index);
        index = renderSuggestionSection(panel, 'Search suggestions', queryItems, index);

        if (!index) {
          close();
          return;
        }

        const viewAll = document.createElement('a');
        viewAll.className = 'p4m-header-search-suggest__view-all';
        viewAll.href = `/search?${headerSearchParams(normalizeHeaderSearchQuery(query)).toString()}`;
        viewAll.textContent = `View all results for "${query}"`;
        viewAll.id = `P4MHeaderSearchSuggestItem-${index}`;
        viewAll.setAttribute('role', 'option');
        viewAll.setAttribute('data-p4m-suggest-item', '');
        panel.appendChild(viewAll);

        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      };

      const update = debounce(async () => {
        const query = normalize(input.value);
        if (query.length < 2) {
          close();
          return;
        }

        const currentRequest = (requestId += 1);
        const normalizedQuery = normalizeHeaderSearchQuery(query);
        const vehicleItem = headerVehicleSuggestion(query);

        if (controller) controller.abort();
        controller = new AbortController();

        try {
          const predictiveResults = await fetchPredictiveSearch(normalizedQuery, controller.signal);
          if (currentRequest !== requestId) return;
          render(query, vehicleItem, predictiveResults);
        } catch (error) {
          if (error.name === 'AbortError') return;
          if (vehicleItem && currentRequest === requestId) render(query, vehicleItem, null);
          else close();
        }
      }, 180);

      input.addEventListener('input', update);
      input.addEventListener('focus', update);
      input.addEventListener('keydown', (event) => {
        if (panel.hidden) return;
        if (event.key === 'Escape') {
          close();
          return;
        }
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          setActive(activeIndex + 1);
          return;
        }
        if (event.key === 'ArrowUp') {
          event.preventDefault();
          setActive(activeIndex - 1);
          return;
        }
        if (event.key === 'Enter' && activeIndex >= 0) {
          const selected = panel.querySelectorAll('[data-p4m-suggest-item]')[activeIndex];
          if (selected instanceof HTMLAnchorElement) {
            event.preventDefault();
            window.location.href = selected.href;
          }
        }
      });

      document.addEventListener('pointerdown', (event) => {
        if (form.contains(event.target) || panel.contains(event.target)) return;
        close();
      });
    });
  }

  function redirectLegacyFooterMaintenanceSearch() {
    if (window.location.pathname !== '/search') return;

    const params = new URLSearchParams(window.location.search);
    if (params.get('type') === 'product' && (params.get('q') || '').trim().toLowerCase() === 'oil') {
      window.location.replace('/pages/accessories');
    }
  }

  function displayLabelForFitmentSearch() {
    if (window.location.pathname !== '/search') return null;

    const params = new URLSearchParams(window.location.search);
    const query = params.get('q') || '';
    const metaobjectMode = params.get('p4m_fitment') === 'metaobject';
    const tagRegex = /\btag:p4m_fitment_[a-z0-9_]+_\d{4}\b/gi;
    const tagMatches = query.match(tagRegex);
    if (!metaobjectMode && !tagMatches?.length) return null;

    const year = normalize(params.get('year'));
    const make = normalize(params.get('make'));
    const model = normalize(params.get('model'));
    const category = normalize(params.get('category'));
    const remainingQuery = metaobjectMode
      ? normalize(params.get('p4m_keyword'))
      : normalize(query.replace(tagRegex, ' ').replace(/\bOR\b/gi, ' ').replace(/[()]/g, ' ').replace(/\s+/g, ' '));
    const rideLabel = buildQuery([year, make, model]);
    const display = buildQuery([rideLabel, remainingQuery || category]);

    return {
      query,
      tag: tagMatches?.[0] || '',
      metaobjectMode,
      display: display || remainingQuery || category || 'Selected motorcycle',
      rideLabel: rideLabel || 'Selected motorcycle',
    };
  }

  function scrubInternalFitmentSearchText() {
    const displayState = displayLabelForFitmentSearch();
    if (!displayState) return;

    document.querySelectorAll('input[type="search"][name="q"]').forEach((input) => {
      if (displayState.metaobjectMode || (displayState.tag && String(input.value || '').includes(displayState.tag))) {
        input.value = displayState.display;
      }
    });

    if (displayState.metaobjectMode) return;

    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || ['SCRIPT', 'STYLE', 'TEXTAREA', 'OPTION'].includes(parent.tagName)) return NodeFilter.FILTER_REJECT;
        return node.nodeValue?.includes(displayState.tag) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      },
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach((node) => {
      node.nodeValue = node.nodeValue
        .replaceAll(displayState.query, displayState.display)
        .replaceAll(displayState.tag, displayState.rideLabel);
    });
  }

  function setHiddenInput(form, name, value) {
    let input = form.querySelector(`input[name="${name}"][data-p4m-generated]`);
    if (!value) {
      input?.remove();
      return;
    }

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.dataset.p4mGenerated = 'true';
      form.appendChild(input);
    }

    input.value = value;
  }

  function setMetaobjectFitmentInputs(form, ride) {
    const match = fitmentMetaobjectMatchForRide(ride);
    const vehicle = match?.id || '';
    const completeRide = Boolean(normalize(ride?.year) && normalize(ride?.make) && normalize(ride?.model));
    const lookup = match?.key || (completeRide ? fitmentMetaobjectRegistryKey(ride) : '');
    setHiddenInput(form, 'p4m_fitment', completeRide ? 'metaobject' : '');
    setHiddenInput(form, 'p4m_vehicle', vehicle);
    setHiddenInput(form, 'p4m_lookup', lookup);
    setHiddenInput(form, fitmentFilterParam(FITMENT_METAFIELD_KEYS[0]), '');
    setHiddenInput(form, fitmentFilterParam(FITMENT_METAFIELD_KEYS[1]), '');
    return vehicle;
  }

  function activateTab(root, tabName) {
    const tabs = Array.from(root.querySelectorAll('[data-p4m-tab]'));
    if (!tabs.length) {
      root.dataset.p4mActiveTab = 'fitment';
      return;
    }

    const activeTab = tabs.some((tab) => tab.dataset.p4mTab === tabName) ? tabName : 'product';
    root.dataset.p4mActiveTab = activeTab;

    tabs.forEach((tab) => {
      const isActive = tab.dataset.p4mTab === activeTab;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    root.querySelectorAll('[data-p4m-tab-panel]').forEach((panel) => {
      const isActive = panel.dataset.p4mTabPanel === activeTab;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  }

  function submitSearch(root, form) {
    const keyword = root.querySelector('[data-p4m-keyword]')?.value;
    const hasModeTabs = root.querySelector('[data-p4m-tab]') !== null;
    const activeTab = root.dataset.p4mActiveTab || (hasModeTabs ? 'product' : 'fitment');
    const shouldUseRide = !hasModeTabs || activeTab === 'fitment';
    const year = shouldUseRide ? root.querySelector('[data-p4m-year]')?.value : '';
    const make = shouldUseRide ? root.querySelector('[data-p4m-make]')?.value : '';
    const model = shouldUseRide ? normalize(root.querySelector('[data-p4m-model]')?.value) : '';
    const category = root.querySelector('[data-p4m-category]')?.value;
    const queryInput = root.querySelector('[data-p4m-query]');
    const ride = { year, make, model };

    if (shouldUseRide && (year || make || model)) saveRide(ride);

    const query = shouldUseRide
      ? buildFitmentQuery({ keyword, year, make, model, category })
      : (window.P4MSearch?.productQuery ? window.P4MSearch.productQuery(keyword, category) : buildQuery([keyword, category]));
    if (!query) {
      window.location.href = '/collections/all';
      return;
    }

    if (queryInput) queryInput.value = query;
    setHiddenInput(form, 'year', year);
    setHiddenInput(form, 'make', make);
    setHiddenInput(form, 'model', model);
    setHiddenInput(form, 'category', category);
    if (shouldUseRide) setMetaobjectFitmentInputs(form, ride);
    setHiddenInput(form, 'p4m_product_search', shouldUseRide ? '' : '1');
    setHiddenInput(form, 'p4m_keyword', normalize(keyword));
    setHiddenInput(form, 'p4m_display_query', shouldUseRide ? '' : normalize(keyword) || normalize(category));
    setHiddenInput(form, 'options[fields]', shouldUseRide ? 'title,body,tag,product_type,vendor,variants.sku,variants.title' : 'title,vendor,product_type,tag,variants.sku');
    form.submit();
  }

  function initRoot(root) {
    if (root.dataset.p4mSearchReady === 'true') return;
    root.dataset.p4mSearchReady = 'true';

    const form = root.querySelector('[data-p4m-search-form]');
    const yearSelect = root.querySelector('[data-p4m-year]');
    const makeSelect = root.querySelector('[data-p4m-make]');
    const modelSelect = root.querySelector('[data-p4m-model]');
    const categorySelect = root.querySelector('[data-p4m-category]');
    const keywordInput = root.querySelector('[data-p4m-keyword]');
    const clearButton = root.querySelector('[data-p4m-clear]');

    if (!form || !yearSelect || !makeSelect || !modelSelect) return;

    const savedRide = getSavedRide();
    const urlParams = new URLSearchParams(window.location.search);
    const initialModelHint = normalizeFitmentToken(urlParams.get('model_hint') || '');
    const initialYear = urlParams.get('year') || savedRide.year || '';
    const initialMake = normalizeVehicleMake(urlParams.get('make') || savedRide.make || '');
    const requestedModel = normalize(urlParams.get('model') || savedRide.model || '');
    const availableInitialModels = vehicleIndex.models(initialYear, initialMake);
    const initialModel = availableInitialModels.find((model) => model.toLowerCase() === requestedModel.toLowerCase())
      || availableInitialModels.find((model) => slugifyTagValue(model) === slugifyTagValue(requestedModel))
      || normalizeVehicleModels(initialMake, requestedModel, initialYear).find((model) => availableInitialModels.includes(model))
      || '';
    const initialRide = {
      year: initialYear,
      make: initialMake,
      model: initialModel,
    };
    const hasRideParams = Boolean(urlParams.get('year') || urlParams.get('make') || urlParams.get('model') || initialModelHint);
    const responsiveDefaultTab = window.matchMedia('(max-width: 749px)').matches
      ? root.dataset.p4mMobileDefaultTab || root.dataset.p4mDefaultTab || 'product'
      : root.dataset.p4mDefaultTab || 'product';
    const initialTab = urlParams.get('p4m_product_search') === '1' ? 'product' : hasRideParams ? 'fitment' : responsiveDefaultTab;

    fillSelect(yearSelect, vehicleIndex.years, 'Select year');
    yearSelect.value = initialRide.year || '';

    const refreshMakes = () => {
      const year = yearSelect.value;
      fillSelect(makeSelect, vehicleIndex.makes(year), 'Select make');
      makeSelect.disabled = false;
    };

    const refreshModels = () => {
      const year = yearSelect.value;
      const make = makeSelect.value;
      let models = make ? vehicleIndex.models(year, make) : [];
      if (initialModelHint) {
        const filteredModels = models.filter((model) => modelMatchFromSearchQuery(initialModelHint, model).matched);
        if (filteredModels.length) models = filteredModels;
      }
      fillSelect(modelSelect, models, 'Select model');
      modelSelect.disabled = !make;
    };

    refreshMakes();
    makeSelect.value = initialRide.make || '';
    refreshModels();
    modelSelect.value = initialRide.model || '';
    if (categorySelect && urlParams.get('category')) {
      categorySelect.value = urlParams.get('category');
    }
    if (keywordInput && !hasRideParams) {
      if (urlParams.has('p4m_keyword')) keywordInput.value = urlParams.get('p4m_keyword');
      else if (urlParams.get('category') && window.P4MSearch?.productKeyword) {
        keywordInput.value = window.P4MSearch.productKeyword(urlParams.get('q') || '', urlParams.get('category'));
      }
    }
    activateTab(root, initialTab);

    root.querySelectorAll('[data-p4m-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        activateTab(root, tab.dataset.p4mTab || 'product');
      });
    });

    yearSelect.addEventListener('change', () => {
      const previousMake = makeSelect.value;
      const previousModel = modelSelect.value;
      refreshMakes();
      makeSelect.value = hasSelectValue(makeSelect, previousMake) ? previousMake : '';
      refreshModels();
      modelSelect.value = hasSelectValue(modelSelect, previousModel) ? previousModel : '';
    });

    makeSelect.addEventListener('change', () => {
      refreshModels();
      modelSelect.value = '';
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      submitSearch(root, form);
    });

    root.querySelectorAll('[data-p4m-term]').forEach((button) => {
      button.addEventListener('click', () => {
        const term = button.dataset.p4mTerm || '';
        if (categorySelect) categorySelect.value = term;
        setPressed(root, term);
      });
    });

    if (categorySelect) {
      categorySelect.addEventListener('change', () => setPressed(root, categorySelect.value));
    }

    if (clearButton) {
      clearButton.addEventListener('click', () => {
        localStorage.removeItem(STORAGE_KEY);
        yearSelect.value = '';
        refreshMakes();
        makeSelect.value = '';
        refreshModels();
        modelSelect.value = '';
        if (categorySelect) categorySelect.value = '';
        if (keywordInput) keywordInput.value = '';
        setPressed(root, '');
        const responsiveDefaultTab = window.matchMedia('(max-width: 749px)').matches
          ? root.dataset.p4mMobileDefaultTab || root.dataset.p4mDefaultTab || 'product'
          : root.dataset.p4mDefaultTab || 'product';
        activateTab(root, responsiveDefaultTab);
      });
    }
  }

  function initCarousel(carousel) {
    if (carousel.dataset.p4mCarouselReady === 'true') return;
    carousel.dataset.p4mCarouselReady = 'true';

    const slides = Array.from(carousel.querySelectorAll('[data-p4m-promo-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-p4m-promo-dot]'));
    const previousButton = carousel.querySelector('[data-p4m-promo-prev]');
    const nextButton = carousel.querySelector('[data-p4m-promo-next]');
    const shouldAutoplay = carousel.dataset.autoplay !== 'false';
    const speed = Math.max(Number(carousel.dataset.speed) || 5000, 2500);
    let activeIndex = Math.max(slides.findIndex((slide) => slide.classList.contains('is-active')), 0);
    let timer = null;

    if (!slides.length) return;

    function show(index) {
      activeIndex = (index + slides.length) % slides.length;

      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === activeIndex);
      });

      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === activeIndex);
        dot.setAttribute('aria-current', dotIndex === activeIndex ? 'true' : 'false');
      });
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      if (!shouldAutoplay || slides.length < 2 || timer) return;
      timer = window.setInterval(() => show(activeIndex + 1), speed);
    }

    previousButton?.addEventListener('click', () => {
      show(activeIndex - 1);
      stop();
      start();
    });

    nextButton?.addEventListener('click', () => {
      show(activeIndex + 1);
      stop();
      start();
    });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        show(Number(dot.dataset.index) || 0);
        stop();
        start();
      });
    });

    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusout', start);

    show(activeIndex);
    start();
  }

  const productJsonCache = new Map();

  function imageFileKey(url) {
    try {
      const parsed = new URL(String(url || ''), window.location.origin);
      return decodeURIComponent(parsed.pathname.split('/').pop() || '').toLowerCase();
    } catch (_error) {
      return decodeURIComponent(String(url || '').split('?')[0].split('/').pop() || '').toLowerCase();
    }
  }

  function productJsonUrl(productForm) {
    const productUrl = productForm?.dataset.productUrl || window.location.pathname;
    return new URL(`${String(productUrl).split('?')[0].replace(/\/$/, '')}.js`, window.location.origin).toString();
  }

  async function fetchProductJson(productForm) {
    const url = productJsonUrl(productForm);
    if (!productJsonCache.has(url)) {
      productJsonCache.set(
        url,
        fetch(url, { credentials: 'same-origin' }).then((response) => {
          if (!response.ok) throw new Error(`Product JSON failed: ${response.status}`);
          return response.json();
        })
      );
    }

    return productJsonCache.get(url);
  }

  function selectedVariantId(productForm) {
    const formVariantId = productForm?.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
    if (formVariantId) return String(formVariantId);

    const urlVariantId = new URLSearchParams(window.location.search).get('variant');
    if (urlVariantId) return urlVariantId;

    return document.querySelector('input[type="radio"][data-variant-id]:checked')?.dataset.variantId || '';
  }

  function hasMultipleColorValues(product) {
    const colorOption = product?.options?.find((option) => String(option?.name || '').toLowerCase() === 'color');
    return Array.isArray(colorOption?.values) && colorOption.values.length > 1;
  }

  function isBootProduct(product) {
    const tags = Array.isArray(product?.tags) ? product.tags.map((tag) => String(tag).toLowerCase()) : [];
    return tags.includes('category:boots') || /\bboot/i.test(`${product?.title || ''} ${product?.type || ''}`);
  }

  function isPirelliSuperbikeSlickProduct(product) {
    return product?.handle === 'pirelli-diablo-superbike-slick-tires' || /pirelli\s+diablo\s+superbike\s+slick\s+tires/i.test(product?.title || '');
  }

  function isPirelliSuperbikeCompoundImageKey(key) {
    return /^pirelli-diablo-superbike-sc(?:x|0|1|2|3)(?:_[^.]*)?\.png$/i.test(String(key || ''));
  }

  function findBuyConfidenceItem(productForm, label) {
    const normalizedLabel = String(label).toLowerCase();
    return Array.from(productForm?.querySelectorAll('.p4m-buy-confidence__item') || []).find((item) => {
      return item.querySelector('.p4m-buy-confidence__label')?.textContent?.trim().toLowerCase() === normalizedLabel;
    });
  }

  function updateBuyConfidenceFallback(productForm, variant, product) {
    if (!productForm || !variant) return;

    const partNumber = findBuyConfidenceItem(productForm, 'Part number');
    const partNumberValue = partNumber?.querySelector('strong');
    const vendorValue = partNumber?.querySelector('small');
    if (partNumberValue) partNumberValue.textContent = variant.sku || 'Ask us to confirm';
    if (vendorValue && product?.vendor) vendorValue.textContent = product.vendor;

    // The server-rendered selected variant combines inventory and supplier
    // lead time. Public product.js data cannot safely replace that authority.
    if (productForm.querySelector('.p4m-buy-confidence[data-p4m-fulfillment-authority="product"]')) return;

    const availability = findBuyConfidenceItem(productForm, 'Availability');
    const availabilityValue = availability?.querySelector('strong');
    const availabilityDetail = availability?.querySelector('small');
    if (!availability || !availabilityValue || !availabilityDetail) return;

    availability.classList.remove(
      'p4m-buy-confidence__item--positive',
      'p4m-buy-confidence__item--warning',
      'p4m-buy-confidence__item--critical',
      'p4m-buy-confidence__item--neutral'
    );

    const shipping = findBuyConfidenceItem(productForm, 'Shipping');
    const shippingText = `${shipping?.querySelector('strong')?.textContent || ''} ${shipping?.querySelector('small')?.textContent || ''}`.toLowerCase();
    const hasBackorderConsent = productForm.querySelector('.p4m-backorder-consent[data-backorder-required="true"]') !== null;
    const isBackorder =
      hasBackorderConsent ||
      shippingText.includes('backorder') ||
      shippingText.includes('factory/supplier') ||
      (variant.available && Number(variant.inventory_quantity || 0) <= 0 && variant.inventory_policy === 'continue');

    if (isBackorder) {
      availability.classList.add('p4m-buy-confidence__item--critical');
      availabilityValue.textContent = 'Factory / supplier backorder';
      availabilityDetail.textContent = 'ETA consent required; typical fulfillment is 2-3 weeks';
    } else if (variant.available) {
      availability.classList.add('p4m-buy-confidence__item--positive');
      availabilityValue.textContent = 'In stock';
      availabilityDetail.textContent = 'Ready for fulfillment';
    } else {
      availability.classList.add('p4m-buy-confidence__item--critical');
      availabilityValue.textContent = 'Out of stock';
      availabilityDetail.textContent = 'Contact us for ETA or alternatives';
    }
  }

  function resetGalleryFilter(gallery) {
    gallery.querySelectorAll('slideshow-slide[data-p4m-variant-filtered]').forEach((slide) => {
      slide.hidden = false;
      slide.style.display = '';
      slide.removeAttribute('data-p4m-variant-filtered');
    });
    delete gallery.dataset.p4mVariantImageFiltered;
  }

  function filterGalleryToSelectedVariant(product, variant) {
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    resetGalleryFilter(gallery);

    if (isPirelliSuperbikeSlickProduct(product)) {
      const selectedKey = imageFileKey(variant?.featured_image?.src);
      if (!selectedKey) return;

      const slides = Array.from(gallery.querySelectorAll('slideshow-slide'));
      let selectedCompoundSlides = 0;

      slides.forEach((slide) => {
        const image = slide.querySelector('img');
        const imageKey = imageFileKey(image?.currentSrc || image?.src || image?.getAttribute('src'));
        const isCompoundImage = isPirelliSuperbikeCompoundImageKey(imageKey);
        const matchesSelectedCompound = imageKey === selectedKey;
        const shouldShow = !isCompoundImage || matchesSelectedCompound;

        slide.hidden = !shouldShow;
        slide.style.display = shouldShow ? '' : 'none';
        slide.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
        slide.dataset.p4mVariantFiltered = 'true';
        if (matchesSelectedCompound) selectedCompoundSlides += 1;
      });

      if (selectedCompoundSlides === 0) {
        resetGalleryFilter(gallery);
        return;
      }

      gallery.dataset.p4mVariantImageFiltered = 'true';
      return;
    }

    if (!isBootProduct(product) || !hasMultipleColorValues(product)) return;

    const selectedKey = imageFileKey(variant?.featured_image?.src);
    if (!selectedKey) return;

    const slides = Array.from(gallery.querySelectorAll('slideshow-slide'));
    let visibleSlides = 0;

    slides.forEach((slide) => {
      const image = slide.querySelector('img');
      const matchesSelectedVariant = imageFileKey(image?.currentSrc || image?.src || image?.getAttribute('src')) === selectedKey;
      slide.hidden = !matchesSelectedVariant;
      slide.style.display = matchesSelectedVariant ? '' : 'none';
      slide.setAttribute('aria-hidden', matchesSelectedVariant ? 'false' : 'true');
      slide.dataset.p4mVariantFiltered = 'true';
      if (matchesSelectedVariant) visibleSlides += 1;
    });

    if (visibleSlides === 0) {
      resetGalleryFilter(gallery);
      return;
    }

    gallery.dataset.p4mVariantImageFiltered = 'true';
  }

  async function syncProductVariantDisplay(root) {
    const productForm = root?.querySelector?.('product-form-component[data-product-url]') || document.querySelector('product-form-component[data-product-url]');
    if (!productForm) return;

    try {
      const product = await fetchProductJson(productForm);
      const variantId = selectedVariantId(productForm);
      const variant = product?.variants?.find((item) => String(item.id) === String(variantId));
      if (!variant) return;

      updateBuyConfidenceFallback(productForm, variant, product);
      filterGalleryToSelectedVariant(product, variant);
    } catch (_error) {
      return;
    }
  }

  function scheduleProductVariantDisplaySync(target) {
    const root = target?.closest?.('.shopify-section') || document;
    [80, 700, 1800].forEach((delay) => {
      window.setTimeout(() => syncProductVariantDisplay(root), delay);
    });
  }

  function initProductVariantDisplay() {
    if (!document.querySelector('product-form-component[data-product-url]')) return;

    syncProductVariantDisplay(document);

    if (document.documentElement.dataset.p4mVariantDisplayReady === 'true') return;
    document.documentElement.dataset.p4mVariantDisplayReady = 'true';

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement) || target.type !== 'radio') return;
      if (!target.closest('.shopify-section')?.querySelector('product-form-component[data-product-url]')) return;

      scheduleProductVariantDisplaySync(target);
    });

    window.addEventListener('popstate', () => scheduleProductVariantDisplaySync(document.body));
  }

  const supplierMetadataPattern = /\s*(Air Freight Prohibited|Not Carb Approved|Carb Acknowledgement Required|Ltl Freight Required|Prop 65|Part Type|Epa|Units Per Sku|Regular Stock):\s*[^<]*?(?=\s*(?:Air Freight Prohibited|Not Carb Approved|Carb Acknowledgement Required|Ltl Freight Required|Prop 65|Part Type|Epa|Units Per Sku|Regular Stock):|$)/gi;

  function cleanSupplierMetadataText(value) {
    return String(value || '').replace(supplierMetadataPattern, '').replace(/\s{2,}/g, ' ').trim();
  }

  function scrubSupplierMetadata() {
    if (!document.body?.textContent?.match(supplierMetadataPattern)) return;

    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    while (walker.nextNode()) {
      if (walker.currentNode.parentElement?.closest('script, style, noscript, template')) continue;
      if (walker.currentNode.nodeValue?.match(supplierMetadataPattern)) textNodes.push(walker.currentNode);
    }

    textNodes.forEach((node) => {
      node.nodeValue = cleanSupplierMetadataText(node.nodeValue);
    });
  }

  function trustContentPage(title, bodyHtml) {
    const main = document.querySelector('main');
    if (!main) return;

    main.innerHTML = `
      <section class="p4m-trust-page page-width" style="padding: 40px 0 56px;">
        <div class="rte" style="max-width: 880px; margin: 0 auto;">
          <h1>${title}</h1>
          ${bodyHtml}
        </div>
      </section>
    `;
  }

  function renderTrustContentFallbacks() {
    const path = window.location.pathname.replace(/\/$/, '');

    if (path === '/pages/contact' && !document.body.textContent.includes('Parts4Motorcycles LLC')) {
      trustContentPage('Contact Parts4Motorcycles', `
        <p>Need order support, fitment help, product information, or return assistance? Contact Parts4Motorcycles before placing an order if you are unsure about fitment, sizing, availability, or shipping timing.</p>
        <p><strong>Company:</strong> Parts4Motorcycles LLC<br>
        <strong>Website:</strong> parts4motorcycles.com<br>
        <strong>Support:</strong> <a href="mailto:support@parts4motorcycles.com">support@parts4motorcycles.com</a><br>
        <strong>Sales:</strong> <a href="mailto:sales@parts4motorcycles.com">sales@parts4motorcycles.com</a><br>
        <strong>Phone:</strong> <a href="tel:+17863095184">+1 (786) 309-5184</a><br>
        <strong>Business address:</strong> 3929 Pembroke Rd, Hollywood, FL 33021, USA</p>
        <p>Parts4Motorcycles is an online motorcycle parts, rider gear, maintenance, and accessories store. Products may be stocked directly or fulfilled through U.S. supplier, distributor, or manufacturer warehouse partners depending on product availability.</p>
        <h2>Returns</h2>
        <p>Please contact us before sending anything back. Returns must be approved first. Review our <a href="/policies/refund-policy">Returns and Refunds policy</a> for eligibility, timing, and shipping responsibilities.</p>
      `);
    }

    if (path === '/policies/refund-policy' && document.body.textContent.includes('return shipping label')) {
      trustContentPage('Returns and Refunds', `
        <p>Parts4Motorcycles LLC accepts return requests for eligible items within 7 days after delivery.</p>
        <h2>Return Eligibility</h2>
        <p>To qualify for a return, the item must be unused, uninstalled, in original condition, and include the original packaging, accessories, manuals, labels, and tags when applicable. Proof of purchase is required.</p>
        <p>All returns must be approved by Parts4Motorcycles before shipment. Items sent back without approval may be refused and may not qualify for a refund.</p>
        <h2>How to Start a Return</h2>
        <p>Email <a href="mailto:support@parts4motorcycles.com">support@parts4motorcycles.com</a> with your order number, the item you want to return, and the reason for the return. If approved, we will provide return instructions.</p>
        <p>Approved returns are sent to: 3929 Pembroke Rd, Hollywood, FL 33021, USA</p>
        <h2>Return Shipping</h2>
        <p>For regular returns, including buyer's remorse, fitment mistakes, or ordering the wrong item, the customer is responsible for return shipping costs.</p>
        <p>If the item is incorrect, defective, or damaged due to our error, contact us within 48 hours of delivery. After review and approval, we will assist with the replacement, refund, or return process at no additional cost to you.</p>
        <h2>Non-Returnable Items</h2>
        <ul>
          <li>Installed, used, worn, or altered parts or gear</li>
          <li>Electrical or electronic components once opened, installed, used, or tested</li>
          <li>Custom, special-order, or manufacturer-direct items marked as non-returnable</li>
          <li>Clearance or final-sale items</li>
          <li>Opened fluids, oils, chemicals, or similar consumable products</li>
          <li>Gift cards</li>
        </ul>
        <h2>Refund Timing</h2>
        <p>Approved refunds are issued to the original payment method after the returned item is received and inspected. Once processed, refunds may take 5-10 business days to appear, depending on your bank or payment provider.</p>
        <p>Original shipping fees are non-refundable unless the return is due to an error by Parts4Motorcycles.</p>
      `);
    }
  }

  function fixFooterLinks() {
    const footer = document.querySelector('.p4m-footer');
    if (!footer) return;

    const replacements = new Map([
      ['/pages/exhaust', '/pages/exhausts'],
      ['/pages/accesories', '/pages/accessories'],
      ['/search?type=product&q=oil', '/pages/accessories'],
    ]);

    footer.querySelectorAll('a[href]').forEach((link) => {
      const href = link.getAttribute('href');
      if (replacements.has(href)) {
        link.setAttribute('href', replacements.get(href));
      }
    });
  }

  const p4mF16CartHandles = [
    'fly-racing-f-16-raze-pants-2027',
    'fly-racing-f-16-raze-jersey-2027',
    'fly-racing-f-16-raze-gloves-2027',
  ];

  function escapeF16CartText(value) {
    return String(value || '').replace(/[&<>'"]/g, (character) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
    })[character]);
  }

  function publishF16CartEvent(name, payload = {}) {
    const detail = { interaction: payload.interaction || name, ...payload };
    if (window.P4MFunnel && typeof window.P4MFunnel.publish === 'function') {
      window.P4MFunnel.publish(name, detail);
      return;
    }
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: name, ...detail });
    try {
      window.Shopify?.analytics?.publish?.(name, detail);
    } catch (_error) {
      return;
    }
  }

  function initF16CartRecommendations() {
    if (window.location.pathname.replace(/\/$/, '') !== '/cart') return;

    const productCache = new Map();
    let syncSequence = 0;
    let scheduleTimer = 0;
    let lastTrackedState = '';

    const recommendationSections = () => Array.from(document.querySelectorAll('h2, h3'))
      .filter((heading) => heading.textContent?.trim().toLowerCase().includes('you may also like'))
      .map((heading) => heading.closest('.shopify-section') || heading.closest('section') || heading.parentElement)
      .filter(Boolean);

    const restoreGenericRecommendations = () => {
      recommendationSections().forEach((section) => {
        if (section.dataset.p4mF16Suppressed !== 'true') return;
        delete section.dataset.p4mF16Suppressed;
        if (section.dataset.p4mNoAvailableRecommendations !== 'true') {
          section.hidden = false;
          section.removeAttribute('aria-hidden');
        }
      });
    };

    const suppressGenericRecommendations = () => {
      recommendationSections().forEach((section) => {
        section.hidden = true;
        section.setAttribute('aria-hidden', 'true');
        section.dataset.p4mF16Suppressed = 'true';
      });
    };

    const fetchProduct = async (handle) => {
      if (!productCache.has(handle)) {
        productCache.set(handle, fetch(`/products/${encodeURIComponent(handle)}.js`, {
          credentials: 'same-origin',
          headers: { accept: 'application/json' }
        }).then((response) => {
          if (!response.ok) throw new Error(`Product read failed (${response.status})`);
          return response.json();
        }));
      }
      return productCache.get(handle);
    };

    const formatPrice = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD'
    }).format(Number(cents || 0) / 100);

    const selectedColor = (item) => {
      const namedColor = item?.options_with_values?.find((option) => /colou?r/i.test(option.name || ''))?.value;
      return String(namedColor || item?.variant_options?.[0] || '').trim();
    };

    const productCard = (product, color) => {
      const variant = product.variants?.find((candidate) => {
        return candidate.available && String(candidate.options?.[0] || '').trim().toLowerCase() === color.toLowerCase();
      }) || product.variants?.find((candidate) => candidate.available) || product.variants?.[0];
      if (!variant) return '';
      const image = variant.featured_image?.src || variant.featured_image || product.featured_image || product.images?.[0] || '';
      const piece = product.handle.includes('pants') ? 'Pants' : product.handle.includes('jersey') ? 'Jersey' : 'Gloves';
      const href = `/products/${encodeURIComponent(product.handle)}?variant=${encodeURIComponent(variant.id)}`;
      return `
        <article class="p4m-f16-cart-kit__card" data-p4m-f16-cart-target="${escapeF16CartText(product.handle)}">
          <a href="${href}" data-p4m-f16-cart-link>
            ${image ? `<img src="${escapeF16CartText(image)}" alt="${escapeF16CartText(product.title)}" loading="lazy" width="180" height="180">` : ''}
          </a>
          <div>
            <span>${piece}${color ? ` · ${escapeF16CartText(color)}` : ''}</span>
            <a href="${href}" data-p4m-f16-cart-link>${escapeF16CartText(product.title)}</a>
            <div><strong>${formatPrice(variant.price)}</strong><a href="${href}" data-p4m-f16-cart-link>Choose size</a></div>
          </div>
        </article>
      `;
    };

    const placeModule = (module) => {
      const recommendation = recommendationSections()[0];
      if (recommendation) {
        if (module.nextElementSibling !== recommendation) recommendation.insertAdjacentElement('beforebegin', module);
        return;
      }
      const main = document.querySelector('main');
      if (main && module.parentElement !== main) main.appendChild(module);
    };

    const sync = async () => {
      const sequence = ++syncSequence;
      try {
        const response = await fetch('/cart.js', {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { accept: 'application/json' }
        });
        if (!response.ok) throw new Error(`Cart read failed (${response.status})`);
        const cart = await response.json();
        if (sequence !== syncSequence) return;

        const f16Items = (cart.items || []).filter((item) => p4mF16CartHandles.includes(item.handle));
        const existing = document.querySelector('[data-p4m-f16-cart-kit]');
        if (!f16Items.length) {
          existing?.remove();
          restoreGenericRecommendations();
          lastTrackedState = '';
          return;
        }

        const cartHandles = new Set(f16Items.map((item) => item.handle));
        const missingHandles = p4mF16CartHandles.filter((handle) => !cartHandles.has(handle));
        const color = selectedColor(f16Items[0]);
        const state = `${Array.from(cartHandles).sort().join('|')}::${missingHandles.join('|')}::${color}`;

        suppressGenericRecommendations();
        const module = existing || document.createElement('section');
        module.className = 'p4m-f16-cart-kit page-width';
        module.dataset.p4mF16CartKit = 'true';
        module.setAttribute('aria-label', 'F-16 Raze matching set');

        if (!missingHandles.length) {
          module.dataset.state = 'complete';
          module.innerHTML = `
            <div class="p4m-f16-cart-kit__complete">
              <span aria-hidden="true">✓</span>
              <div><strong>Your matching F-16 Raze kit is complete.</strong><small>Pants, jersey, and gloves are together. Continue when you are ready.</small></div>
            </div>
          `;
        } else {
          module.dataset.state = 'incomplete';
          const products = await Promise.all(missingHandles.map(fetchProduct));
          if (sequence !== syncSequence) return;
          module.innerHTML = `
            <div class="p4m-f16-cart-kit__heading">
              <span>Matching pieces only</span>
              <h2>Complete your F-16 Raze kit</h2>
              <p>${color ? `Keep <strong>${escapeF16CartText(color)}</strong> together. ` : ''}Choose the right size on each product page.</p>
            </div>
            <div class="p4m-f16-cart-kit__grid">${products.map((product) => productCard(product, color)).join('')}</div>
          `;
        }
        placeModule(module);

        module.querySelectorAll('[data-p4m-f16-cart-link]').forEach((link) => {
          link.addEventListener('click', () => {
            publishF16CartEvent('p4m_matching_set_cart_item_opened', {
              interaction: 'matching_set_cart_item_opened',
              target_handle: link.closest('[data-p4m-f16-cart-target]')?.dataset.p4mF16CartTarget || '',
              complete_kit: missingHandles.length === 0
            });
          }, { once: true });
        });

        if (lastTrackedState !== state) {
          lastTrackedState = state;
          publishF16CartEvent('p4m_matching_set_cart_state', {
            interaction: missingHandles.length ? 'matching_set_cart_incomplete' : 'matching_set_cart_complete',
            present_count: cartHandles.size,
            missing_count: missingHandles.length,
            matching_color: color
          });
        }
      } catch (_error) {
        return;
      }
    };

    const schedule = (delay = 80) => {
      window.clearTimeout(scheduleTimer);
      scheduleTimer = window.setTimeout(sync, delay);
    };

    sync();
    window.setTimeout(sync, 650);
    window.setTimeout(sync, 1800);
    document.addEventListener('cart:update', () => schedule(80));
    document.addEventListener('cart:refresh', () => schedule(80));
    window.addEventListener('pageshow', () => schedule(40));
    const cartRoot = document.querySelector('cart-items-component');
    if (cartRoot) new MutationObserver(() => schedule(120)).observe(cartRoot, { subtree: true, childList: true });
  }

  function initCartConversionHygiene() {
    if (window.location.pathname.replace(/\/$/, '') !== '/cart') return;

    if (!document.querySelector('#p4m-cart-conversion-styles')) {
      const style = document.createElement('style');
      style.id = 'p4m-cart-conversion-styles';
      style.textContent = `
        .cart-page__summary .cart__summary-inner > .p4m-cart-shipping-promise,
        .cart-page__summary .cart__summary-inner > .p4m-cart-summer10 {
          align-self: stretch;
        }
        .p4m-cart-shipping-promise {
          display: grid;
          gap: 3px;
          margin: 12px 0;
          padding: 11px 12px;
          border: 1px solid #d7dce3;
          border-radius: 10px;
          background: #f7faf8;
          color: #20252b;
          font-size: 12px;
          line-height: 1.35;
          text-align: left;
        }
        .p4m-cart-shipping-promise strong { color: #08783e; font-size: 13px; }
        .p4m-cart-shipping-promise small { color: #5a626d; font-size: 11px; }
        .p4m-cart-shipping-promise a { color: #20252b; font-weight: 800; }
        .p4m-cart-summer10 {
          display: grid;
          gap: 5px;
          margin: 12px 0;
          padding: 12px;
          border: 1px solid #efb7ba;
          border-radius: 10px;
          background: #fff7f7;
          color: #20252b;
          font-size: 12px;
          line-height: 1.35;
          text-align: left;
        }
        .p4m-cart-summer10__eyebrow {
          color: #b51219;
          font-size: 10px;
          font-weight: 900;
          letter-spacing: .08em;
          text-transform: uppercase;
        }
        .p4m-cart-summer10 strong {
          color: #20252b;
          font-size: 14px;
        }
        .p4m-cart-summer10__action {
          display: inline-flex;
          min-height: 42px;
          align-items: center;
          justify-content: center;
          margin-top: 4px;
          padding: 9px 14px;
          border-radius: 8px;
          background: #d71920;
          color: #fff;
          font-size: 12px;
          font-weight: 900;
          letter-spacing: .03em;
          text-decoration: none;
        }
        .p4m-cart-summer10__action:hover { background: #b51219; color: #fff; }
        .p4m-cart-summer10[data-state="applied"] {
          border-color: #a8d8bb;
          background: #f4fbf7;
        }
        .p4m-cart-summer10[data-state="applied"] .p4m-cart-summer10__eyebrow {
          color: #08783e;
        }
        .p4m-cart-mobile-momentum,
        .p4m-cart-express-label {
          display: none;
        }
        .p4m-f16-cart-kit {
          margin-block: 26px;
          padding-block: 18px;
          border-block: 1px solid #d9dde3;
          color: #17191d;
        }
        .p4m-f16-cart-kit__heading > span {
          color: #b51219;
          font-size: 10px;
          font-weight: 900;
          letter-spacing: .075em;
          text-transform: uppercase;
        }
        .p4m-f16-cart-kit__heading h2 { margin: 3px 0 0; font-size: 22px; }
        .p4m-f16-cart-kit__heading p { margin: 5px 0 14px; color: #606873; font-size: 13px; }
        .p4m-f16-cart-kit__grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; }
        .p4m-f16-cart-kit__card { display: grid; grid-template-columns: 112px minmax(0, 1fr); gap: 12px; padding: 10px; border: 1px solid #e1e4e8; border-radius: 11px; background: #fff; }
        .p4m-f16-cart-kit__card > a { display: block; aspect-ratio: 1; overflow: hidden; border-radius: 8px; background: #f3f4f6; }
        .p4m-f16-cart-kit__card img { width: 100%; height: 100%; object-fit: contain; }
        .p4m-f16-cart-kit__card > div { display: grid; align-content: center; gap: 7px; min-width: 0; }
        .p4m-f16-cart-kit__card > div > span { color: #08783e; font-size: 10px; font-weight: 850; letter-spacing: .04em; text-transform: uppercase; }
        .p4m-f16-cart-kit__card > div > a { color: #17191d; font-size: 13px; font-weight: 800; line-height: 1.3; text-decoration: none; }
        .p4m-f16-cart-kit__card > div > div { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
        .p4m-f16-cart-kit__card > div > div > a { padding: 8px 10px; border-radius: 7px; background: #d71920; color: #fff; font-size: 11px; font-weight: 900; text-decoration: none; }
        .p4m-f16-cart-kit__complete { display: flex; align-items: center; gap: 12px; padding: 14px; border: 1px solid #a8d8bb; border-radius: 11px; background: #f4fbf7; }
        .p4m-f16-cart-kit__complete > span { display: grid; width: 34px; height: 34px; place-items: center; flex: 0 0 auto; border-radius: 50%; background: #08783e; color: #fff; font-weight: 950; }
        .p4m-f16-cart-kit__complete div { display: grid; gap: 2px; }
        .p4m-f16-cart-kit__complete small { color: #556069; font-size: 12px; }
        @media (max-width: 749px) {
          .p4m-cart-confidence {
            display: none !important;
          }
          .p4m-cart-shipping-promise {
            display: grid !important;
            margin: 8px 0 10px;
            padding: 10px 12px;
          }
          .p4m-cart-summer10 {
            grid-template-columns: minmax(0, 1fr) auto;
            align-items: center;
            gap: 10px;
            margin: 8px 0 10px;
            padding: 10px 12px;
            border-color: #efb7ba;
            border-radius: 10px;
            background: #fffafa;
          }
          .p4m-cart-summer10__eyebrow,
          .p4m-cart-summer10 > span:last-of-type {
            display: none;
          }
          .p4m-cart-summer10 strong {
            font-size: 13px;
            line-height: 1.25;
          }
          .p4m-cart-summer10__action {
            min-height: 40px;
            margin: 0;
            padding: 8px 12px;
            border: 1px solid #d71920;
            background: #fff;
            color: #b51219;
            font-size: 11px;
            white-space: nowrap;
          }
          .p4m-cart-summer10__action:hover {
            background: #fff3f3;
            color: #9f1016;
          }
          .p4m-cart-summer10[data-state="applied"] {
            grid-template-columns: minmax(0, 1fr);
            margin-bottom: 8px;
            padding: 10px 12px;
          }
          .p4m-cart-summer10[data-state="applied"] strong::before {
            content: '✓';
            margin-right: 7px;
            color: #08783e;
            font-weight: 950;
          }
          .cart__ctas > .cart__checkout-button {
            min-height: 56px;
            margin: 0;
            border: 1px solid #d71920;
            border-radius: 10px;
            background: #d71920;
            color: #fff;
            font-size: 16px;
            font-weight: 950;
            letter-spacing: .01em;
            box-shadow: 0 7px 16px rgba(183, 18, 25, .18);
          }
          .cart__ctas > .cart__checkout-button:hover {
            border-color: #b51219;
            background: #b51219;
            color: #fff;
          }
          .p4m-cart-mobile-momentum {
            display: grid;
            gap: 5px;
            margin: 10px 0 13px;
            color: #555d68;
            font-size: 11px;
            line-height: 1.35;
            text-align: left;
          }
          .p4m-cart-mobile-momentum span::before {
            content: '✓';
            margin-right: 7px;
            color: #08783e;
            font-weight: 950;
          }
          .p4m-cart-express-label {
            display: flex;
            align-items: center;
            gap: 9px;
            margin: 4px 0 10px;
            color: #6a717c;
            font-size: 10px;
            font-weight: 850;
            letter-spacing: .06em;
            text-transform: uppercase;
          }
          .p4m-cart-express-label::before,
          .p4m-cart-express-label::after {
            content: '';
            height: 1px;
            flex: 1 1 auto;
            background: #dfe3e8;
          }
          #smile-ui-lite-launcher-frame-container,
          #smile-lite-launcher-frame {
            display: none !important;
            width: 0 !important;
            height: 0 !important;
            visibility: hidden !important;
            pointer-events: none !important;
          }
          .p4m-f16-cart-kit { margin-block: 18px; padding-block: 14px; }
          .p4m-f16-cart-kit__heading h2 { font-size: 18px; }
          .p4m-f16-cart-kit__grid { grid-template-columns: minmax(0, 1fr); gap: 8px; }
          .p4m-f16-cart-kit__card { grid-template-columns: 88px minmax(0, 1fr); gap: 10px; padding: 8px; }
          .p4m-f16-cart-kit__card > div > div > a { padding: 8px; }
        }
        @media (min-width: 750px) {
          .p4m-cart-summer10 {
            grid-template-columns: minmax(0, 1fr) auto;
            align-items: center;
            column-gap: 16px;
          }
          .p4m-cart-summer10__action {
            grid-column: 2;
            grid-row: 1 / span 3;
            min-width: 190px;
            margin-top: 0;
          }
        }
      `;
      document.head.appendChild(style);
    }

    const hasSummer10 = (summary) => {
      return Array.from(summary.querySelectorAll('[data-discount-code]')).some((node) => {
        return String(node.getAttribute('data-discount-code') || '').trim().toLowerCase() === 'summer10';
      });
    };

    const renderSummer10 = (checkoutButton, summary, shippingPromise) => {
      if (!checkoutButton || !summary || !shippingPromise) return;

      let offer = summary.querySelector('[data-p4m-cart-summer10]');
      if (!offer) {
        offer = document.createElement('div');
        offer.className = 'p4m-cart-summer10';
        offer.dataset.p4mCartSummer10 = 'true';
        offer.setAttribute('aria-label', 'SUMMER10 cart offer');
      }
      if (shippingPromise.nextElementSibling !== offer) {
        shippingPromise.insertAdjacentElement('afterend', offer);
      }

      const state = hasSummer10(summary) ? 'applied' : 'available';
      if (offer.dataset.state === state) return;
      offer.dataset.state = state;

      if (state === 'applied') {
        offer.setAttribute('role', 'status');
        offer.innerHTML = `
          <span class="p4m-cart-summer10__eyebrow">Offer applied</span>
          <strong>SUMMER10 applied — 10% off</strong>
          <span>Your savings are included in the total shown above.</span>
        `;
        return;
      }

      offer.removeAttribute('role');
      offer.innerHTML = `
        <span class="p4m-cart-summer10__eyebrow">Current offer</span>
        <strong>Save 10% with SUMMER10</strong>
        <span>One tap updates your total before payment.</span>
        <a
          class="p4m-cart-summer10__action"
          href="/discount/SUMMER10?redirect=/cart"
          data-p4m-promo-code="SUMMER10"
          data-p4m-promo-location="cart_one_tap"
        >Apply 10% off</a>
      `;
    };

    const renderMobileDecisionStack = (checkoutButton, summary) => {
      if (!checkoutButton || !summary) return;

      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      checkoutButton.dataset.p4mOriginalLabel ||= checkoutButton.textContent?.trim() || 'Check out';
      const desiredLabel = isMobile ? 'Continue to checkout' : checkoutButton.dataset.p4mOriginalLabel;
      if (checkoutButton.textContent?.trim() !== desiredLabel) checkoutButton.textContent = desiredLabel;

      let momentum = summary.querySelector('[data-p4m-cart-mobile-momentum]');
      if (!momentum) {
        momentum = document.createElement('div');
        momentum.className = 'p4m-cart-mobile-momentum';
        momentum.dataset.p4mCartMobileMomentum = 'true';
        momentum.setAttribute('role', 'note');
        momentum.setAttribute('aria-label', 'Checkout reassurance');
        momentum.innerHTML = `
          <span>Secure encrypted checkout</span>
          <span>Fulfillment timing varies by product</span>
          <span>P4M order support after purchase</span>
        `;
        checkoutButton.insertAdjacentElement('afterend', momentum);
      }

      const accelerated = checkoutButton.parentElement?.querySelector('.additional-checkout-buttons');
      if (accelerated && !summary.querySelector('[data-p4m-cart-express-label]')) {
        const label = document.createElement('div');
        label.className = 'p4m-cart-express-label';
        label.dataset.p4mCartExpressLabel = 'true';
        label.textContent = 'Or checkout faster with';
        accelerated.insertAdjacentElement('beforebegin', label);
      }
    };

    const apply = () => {
      const summary = document.querySelector('.cart-page__summary');
      const checkoutButton = summary?.querySelector('.cart__ctas > button[name="checkout"], .cart__ctas > button#checkout');
      const checkoutGroup = checkoutButton?.closest('.cart__ctas');
      let promise = summary?.querySelector('[data-p4m-cart-shipping-promise]');
      if (checkoutGroup && !promise) {
        promise = document.createElement('div');
        promise.className = 'p4m-cart-shipping-promise';
        promise.dataset.p4mCartShippingPromise = 'true';
        promise.setAttribute('role', 'note');
        promise.innerHTML = `
          <strong>Estimated U.S. delivery</strong>
          <span>Most standard orders arrive in 3-5 business days after shipment.</span>
          <small>Shipping is not available to Alaska, Hawaii, or Puerto Rico.</small>
          <a href="/policies/shipping-policy">Shipping details</a>
        `;
      }
      if (checkoutGroup && promise && checkoutGroup.nextElementSibling !== promise) {
        checkoutGroup.insertAdjacentElement('afterend', promise);
      }
      renderSummer10(checkoutButton, summary, promise);
      renderMobileDecisionStack(checkoutButton, summary);

      const recommendationHeadings = Array.from(document.querySelectorAll('h2, h3')).filter((heading) => {
        return heading.textContent?.trim().toLowerCase().includes('you may also like');
      });

      recommendationHeadings.forEach((heading) => {
        const section = heading.closest('.shopify-section') || heading.closest('section') || heading.parentElement;
        if (!section) return;

        const cards = Array.from(section.querySelectorAll('product-card'));
        if (!cards.length) return;

        cards.forEach((card) => {
          const isSoldOut = /\bsold out\b/i.test(card.textContent || '');
          if (!isSoldOut) return;
          const wrapper = card.closest('li, .resource-list__item, .product-grid__item') || card;
          wrapper.hidden = true;
          wrapper.setAttribute('aria-hidden', 'true');
          wrapper.dataset.p4mUnavailableRecommendation = 'true';
        });

        const availableCards = cards.filter((card) => {
          return !card.closest('[data-p4m-unavailable-recommendation="true"]');
        });
        if (availableCards.length === 0) {
          section.hidden = true;
          section.setAttribute('aria-hidden', 'true');
          section.dataset.p4mNoAvailableRecommendations = 'true';
        }
      });
    };

    let scheduled = false;
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(() => {
        scheduled = false;
        apply();
      });
    };

    apply();
    const observer = new MutationObserver(schedule);
    const cartRoot = document.querySelector('cart-items-component') || document.body;
    observer.observe(cartRoot, { subtree: true, childList: true });
    document.addEventListener('cart:update', schedule);
    document.addEventListener('cart:refresh', schedule);
    document.addEventListener('shopify:section:load', schedule);
    window.matchMedia('(max-width: 749px)').addEventListener?.('change', schedule);
  }

  function initPromoTracking() {
    if (window.__p4mPromoTrackingReady === true) return;
    window.__p4mPromoTrackingReady = true;

    document.addEventListener('click', (event) => {
      const target = event.target?.closest?.('[data-p4m-promo-code]');
      if (!target) return;

      const promoCode = String(target.dataset.p4mPromoCode || '').trim();
      const promoLocation = String(target.dataset.p4mPromoLocation || '').trim();
      if (!promoCode) return;

      const payload = {
        event: 'p4m_promo_click',
        promo_code: promoCode,
        promo_location: promoLocation,
        promo_href: target.getAttribute('href') || '',
      };

      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(payload);
      }

      try {
        window.Shopify?.analytics?.publish?.('p4m_promo_click', payload);
      } catch (_error) {
        return;
      }
    }, { capture: true });
  }

  function initMobileCartMomentum() {
    if (!document.querySelector('[data-p4m-mobile-view-cart]')) return;

    const mobileMedia = window.matchMedia('(max-width: 749px)');
    let syncSequence = 0;

    const applyState = (itemCount) => {
      const safeCount = Number.isFinite(itemCount) && itemCount > 0 ? Math.floor(itemCount) : 0;
      const showViewCart = mobileMedia.matches && safeCount > 0;
      document.querySelectorAll('[data-p4m-mobile-view-cart]').forEach((link) => {
        link.hidden = !showViewCart;
        link.setAttribute('aria-label', `View cart, ${safeCount} ${safeCount === 1 ? 'item' : 'items'}`);
        const count = link.querySelector('strong');
        if (count) count.textContent = `${safeCount} in cart`;
        const summary = link.parentElement?.querySelector('[data-p4m-purchase-bar-summary]');
        if (summary) summary.hidden = showViewCart;
      });
    };

    const sync = async () => {
      const sequence = ++syncSequence;
      if (!mobileMedia.matches) {
        applyState(0);
        return;
      }

      try {
        const response = await fetch('/cart.js', {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { accept: 'application/json' }
        });
        if (!response.ok) throw new Error(`Cart read failed (${response.status})`);
        const cart = await response.json();
        if (sequence !== syncSequence) return;
        applyState(Number(cart.item_count));
      } catch (_error) {
        if (sequence === syncSequence) applyState(0);
      }
    };

    sync();
    document.addEventListener('cart:update', () => window.setTimeout(sync, 60));
    document.addEventListener('cart:refresh', sync);
    window.addEventListener('pageshow', sync);
    mobileMedia.addEventListener?.('change', sync);
  }

  function init() {
    fixFooterLinks();
    initCartConversionHygiene();
    initF16CartRecommendations();
    initMobileCartMomentum();
    initPromoTracking();
    redirectLegacyFooterMaintenanceSearch();
    redirectLooseFitmentSearch();
    initHeaderSearchAutocomplete();
    document.querySelectorAll('[data-p4m-storefront-search]').forEach(initRoot);
    document.querySelectorAll('[data-p4m-promo-carousel]').forEach(initCarousel);
    scrubInternalFitmentSearchText();
    initProductVariantDisplay();
    scrubSupplierMetadata();
    renderTrustContentFallbacks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
